import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";

import { Redirect } from "react-router-dom";
import { ChosenLoan, LoanProduct, service, fees } from "../../State";
import * as com from "../../Common.js";
import "react-credit-cards/es/styles-compiled.css";
import { connect } from "react-redux";
import { MonhtlyChangeBP } from "../../Common/Tooltip";
import * as act from "../../Store/actions";
import { getCurrentState } from "../../Store";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import {
  // Cascader,
  Select,
  Table,
  Button,
  Skeleton,
  Modal as Mod,
  Row as RowAnt,
  Col as ColAnt,
  InputNumber,
  Tooltip,
  Checkbox
} from "antd";
import * as st from "../../State";
import "./ProductFilterModal.css";
import { ExclamationCircleOutlined, CheckOutlined } from "@ant-design/icons";
import CompareProduct from "../../Tools/MortgageCalculators/CompareProductModal";
import { getDTI as getDTIFromCommon } from "../DTICalculator/getDTIResult"
import { getDTI , getLTV , getOccupancy , getPropertyType , getCitizenship } from "../../Interview/ProductPicker";
import {
  patchSelectionV2,
  patchPropertyFieldsV2,
  patchLoanFieldsV2,
} from "../../DocumentChecklist/applicationV2Client"
import { formatDollars, parseDollars, warningSuffix } from "./moneyInput"
const mapStateToProps = (state) => {
  return {
    application: state.application,
    property: state.application.property,
    selection: state.application.selection,
    borrower: state.borrower,
  };
};

const mapDispatchToProps = (dispatch) => ({

  updateSelectField: (input, verb) => {
    dispatch(act.UpdateSelectField(input, verb));
  },
  updateSelectedLoanField: (input, verb) => {
    dispatch(act.UpdateSelectedLoanField(input, verb))
  },
  updateApplicationAttribute: (input, verb) => {
    dispatch(act.UpdateApplicationAttribute(input, verb));
  },
  changeMainProperty: (value, verb) => {
    dispatch(act.ChangeMainProperty(value, verb))
  },
  updateDTICalculation: (input, verb) => {
    dispatch(act.UpdateDTICalculation(input, verb));
  },

  updateFico: (score) => {
    return new Promise((resolve) => {
      dispatch(act.UpdateFico(score));
      resolve();
    });
  },
});

var hash = require("object-hash");

const typeoptions = [
  { label: "ARM 5/6", value: "arm56" },
  { label: "ARM 7/6", value: "arm76" },
  { label: "ARM 10/6", value: "arm106" },
  { label: "Fixed", value: "fixed" },
];

const termoptions = [
  { label: "30 year", value: 30 },
  { label: "25 year", value: 25 },
  { label: "20 year", value: 20 },
  { label: "15 year", value: 15 },
  { label: "10 year", value: 10 },
];
export const productReload = function (predti) {
  if (null == this.loaded)
      return
  // this one needs work
  let [citizenship, visa] = this.getCitizenship()

  if (this.props.application.product.mortgageapplied === "nonqm") {
      let incomeamount = com.safeParseFloat(this.props.application.borrower.nonqm.nonqmincomeamount)
      if (this.props.application.borrower.nonqm.nonqmincomeperiod === "yearly") {
          incomeamount = Math.round(incomeamount / 12)
      }
      predti.dtiData[0].monthly_income = incomeamount
  } else {
    predti.dtiData[0].monthly_income = this.state.income
  }
  predti.dtiData[0].monthly_payment = this.state.liabilities

  
  const getDSCR = () => {
    let monthlyDebt = com.safeParseInt(predti.dtiData[0].monthly_payment)
    if (com.safeParseInt(monthlyDebt) !== 0) {
      return parseFloat(
        (
          com.safeParseInt(this.props.application.borrower.nonqm.nonqmincomeamount) /
          monthlyDebt
        ).toFixed(2)
      );
    }
    return 100;
  };
  let propertyvalue = this.state.propertyvalue
  let request = {
      state: this.state.propertystate,
      county: this.state.propertycounty,
      purpose: com.Purpose2Calculator(this.props.property.purpose),
      loanAmount: com.safeParseInt(this.state.loansize),
      appraisal: propertyvalue.toString(),
      estimatedClosingCosts: this.fees,
      firstTimeHomeBuyer: this.state.firstTimeHomeBuyer,
      units: this.state.propertytype.propertytype === "twotofourfamily" ? com.safeParseInt(this.props.application.property.units) : 1,
      occupancy: this.getOccupancy(), // propagated
      selfemployed: this.props.application.borrower.occupation.selfemployed,
      property: com.getPropertyType(this.state.propertytype),
      citizenship: citizenship,
      visaType: visa,
      incomeDocumentationType: this.props.application.product.mortgageapplied === "nonqm" ? "" : "FullDoc",
      DSCR: getDSCR(),
      preDTI: predti,
      nonQMDocTypes: this.props.application.borrower.nonqm.nonqmincometype,
  }

  let token = sessionStorage.getItem("ZeitroA")
  this.setState({ loading: true })
  fetch('/data/getproducts', {
      method: 'POST',
      headers: {
          Authorization: "Bearer " + token,
          Cache: "no-cache",
          "Content-Type": "application/json",
          "X-Borrower": this.props.borrowerid,
      },
      body: JSON.stringify(request)
  }).then(
      response => {
          if (response.status !== 200) {

              this.setState({
                  loading: false, errorText: <h1 className='mt-5'>Server error</h1>,
                  products: [], topProducts: []
              })
              if (this.failedProduct != null)
                  this.failedProduct()
              return;
          }
          response.json().then(pr => {

              let products = pr.result
              let status = pr.status
              if ("Ok" !== status) {
                  /*
                  - "0" # InternalError
                  - "1" # LowFICOError
                  - "2" # HighDTIError
                  - "3" # HighLTVError
                  - "4" # LowIncomeError
                  - "5" # MatrixNotFoundError
                  - "6" # UnqualifiedPropertyError
                  */

                  let msg = ""
                  let showDetails = () => {
                      if (pr == null) return ""
                      if ("undefined" !== typeof this.props.borrowerid) {
                          let out = []
                          let reasons = pr["ineligible_reasons"]
                          if (reasons == null) return ""
                          for (const [key, value] of Object.entries(reasons)) {
                              let entry = <div className="mt-2" style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{com.capitalize(key)}</div>
                              out.push(<div> {entry} </div>)
                              if (value.LenderLevelReason !== "")
                                  out.push(<div>{value.LenderLevelReason}</div>)
                              else {
                                  let preasons = value.ProductLevelReasons
                                  /* eslint-disable-next-line no-unused-vars */
                                  if (preasons !== null) {
                                      for (const [key, value] of Object.entries(preasons)) {
                                          out.push(<div>{value.ProductName}: {value.IneligibleReason} </div>)
                                      }
                                  }
                              }

                          }
                          return out
                      } else
                          return ""

                  }
                  msg = <h5 className='sectionquestion my-5 text-wrap text-center'><span style={{ color: '#993333' }}>Matching engine could not find a suitable loan. Reason: </span> <br />{pr["message"]}<br /> <div className="text-left" style={{ fontSize: '0.7em' }}>{showDetails()}</div> </h5>
                  this.setState({
                      loading: false, errorText: msg, errorCode: pr["status code"],
                      products: [], topProducts: []
                  })
                  if (this.failedProduct != null)
                      this.failedProduct()
                  return
              }
              if (this.askedForAssistance()) {
                  products = this.filterForAssistance(products)
              }
              this.setState({ closingCostsDetail: pr.appliedClosingCostsDetail })
              this.processProducts(products)
              this.setState({ loading: false })
          })
      }

  ).catch((err) => {
      this.setState({ loading: false })
      this.setState({
          loading: false, errorText: <h1 className='mt-5'>{"Network Error"} </h1>,
          products: [], topProducts: []
      })
      if (this.failedProduct != null)
          this.failedProduct()
  });
}
export class ProductFilterModal extends React.Component {
  // 添加defaultProps静态属性
  static defaultProps = {
    open: false,
    onCancel: () => {},
    onConfirm: () => {}
  };

  constructor(props) {
    super(props);
    this.state = {
      typeselected: [],
      termselected: [],
      yearstohold: 7,

      loansize: 0,
      products: [],
      topProducts: [],
      loading: false,
      weightclosing: this.props.selection.weightclosing,
      weighttotalcost: this.props.selection.weighttotalcost,
      weightmonthly: this.props.selection.ƒTriangggweightmonthly,
      showSelf: false,
      ltv: 60.0,
      cltv: 0,
      fico: this.props.application.scre,
      propertyvalue: 0,
      propertystate: "",
      propertycounty: "",
      currentbalance: 0,
      firstTimeHomeBuyer: this.props.application.firsttimebuyer,
      income: 0,
      liabilities: 0,
      occupancy: "PRIMARY",
      propertytype: "",
      property: "SINGLE_FAMILY_DETACHED",
      errorText: "",
      searchParams: {},
      downpayment: 30000,
      defdownpayment: 30000,
      viewkey: 0,
      paydown: 0,
      cashout: 30000,
      targetprice: 1,
      redirect: "",
      positionbyemail: {},
      statusloaded: false,
      showHelp: true,
      show: false,
      detailedCard: null,
      lenders: [],
      selectedlenders: ['all'],
      mtypes: [],
      selectedmtypes: ['all'],
      incomedoctypes: [],
      selectedincomedoctypes: [],
      selectedmaxreserves: -1,
      maxreserves: -1,
      showPriceChanged: false,
      selectedImage: null,
      needsAdjustment: false,
      comparisonSelections: {},
      mincashout: 0,
      dtiSpreadsheetLoading: false,

      ratesToBeRecommended: [],
      showRecommendRatesModal: false,
      compareModal: false,
      showLeftButton: false,
      showRightButton: true,
      isModalOpen: false,
      // 新增: 排序状态
      sortOrder: null,
      sortColumn: null,
      showFilterForm: false,
      isEditFilter: false,
      loanLimits: []
    };
    this.filtersWrapRef = React.createRef();
    this.hcltv = null;
    this.cltv = null;
    this.timer = 0;
    this.lenders = [];
    this.mtypes = [];
    this.incomedoctypes = [];
    this.changeshown = false;
    this.oldmaxupfrontcost = null;
    this.howmany2display = 5;
    if (this.props.borrowerid) this.howmany2display *= 3;
    switch (this.props.property.purpose) {
      case "purchase":
        if (this.props.selection.selectedloan.hash !== "") {
          this.state.loansize = this.props.selection.loansize;
          this.state.downpayment = this.state.defdownpayment =
            com.safeParseInt(this.props.property.salesprice) -
            this.state.loansize;
          this.props.updateSelectField(this.state.downpayment, "downpayment");
        } else {
          this.state.downpayment = com.safeParseInt(
            this.props.selection.downpayment
          );
          this.state.defdownpayment = com.safeParseInt(
            this.props.selection.downpayment
          );
          this.state.loansize =
            com.safeParseInt(this.props.property.salesprice) -
            com.safeParseInt(this.state.downpayment);
        }
        break;
      case "refinance":
        if (this.props.selection.selectedloan.hash !== "") {
          this.state.loansize = this.props.selection.loansize;
          this.state.downpayment = this.state.defdownpayment =
            com.safeParseInt(this.props.application.loanbalance) -
            this.state.loansize;
          this.props.updateSelectField(this.state.downpayment, "paydown");
        } else {
          this.state.downpayment = com.safeParseInt(
            this.props.selection.paydown
          );
          this.state.defdownpayment = com.safeParseInt(
            this.props.selection.paydown
          );
          this.state.loansize =
            com.safeParseInt(this.props.application.loanbalance) -
            com.safeParseInt(this.props.selection.paydown);
        }
        break;
      case "cashoutrefinance":
        this.state.lmincashout = this.props.selection.selectedloan.min;
        if (this.props.selection.selectedloan.hash !== "") {
          this.state.loansize = this.props.selection.loansize;
          this.state.downpayment = this.state.defdownpayment =
            this.state.loansize -
            com.safeParseInt(this.props.application.loanbalance);
          if (this.state.downpayment <= 0) {
            this.state.downpayment = this.state.defdownpayment = 30000;
          }
          this.props.updateSelectField(this.state.downpayment, "cashout");
        } else {
          this.state.downpayment = com.safeParseInt(
            this.props.selection.cashout
          );
          this.state.defdownpayment = com.safeParseInt(
            this.props.selection.cashout
          );
          this.state.loansize =
            com.safeParseInt(this.props.application.loanbalance) +
            com.safeParseInt(this.props.selection.cashout);
        }
        break;
      default:
        // alert("should not see this!")
        break;
    }

    // this.props.updateSelectField(this.state.loansize.toString(), "loansize");
    this.downloadDTIspreadsheetRef = React.createRef();

    this.getTermOptions().forEach((term) => {
      if (this.props.selection.loanterms.includes("year" + term.value))
        this.state.termselected.push(term.value);
    });
    if (this.state.termselected.length === 0)
      this.state.termselected = [this.getTermOptions()[0].value];

    typeoptions.forEach((typ) => {
      if (this.props.selection.loanamortizations.includes(typ.value))
        this.state.typeselected.push(typ.value);
    });
    if (this.state.typeselected.length === 0)
      this.state.typeselected = ['all']; // typeoptions.map((x) => x.value);
    this.cull = (a) => a;
    this.selectsort(this.props.selection.sortby);

    this.width = 250;

    // console.log('this.props.property.purpose', this.props.property.purpose, this.props.property.hascontract)
    this.isPrequal =
      this.props.property.purpose === "purchase" &&
      this.props.property.hascontract === false;
    this.height = Math.floor((this.width / 2) * Math.tan(3.14 / 3.0));
    if (this.props.property.salesprice === "") {
      this.state.redirect = <Redirect to="/app/interview/main?section=start" />;
    }
    this.rawproducts = [];
    this.checkStatus();
    this.getLoanLimits()
    // backup
    this.loanbalance = this.state.loansize.toString();
    this.down = this.state.defdownpayment;

    this.amortizations = [...this.props.selection.loanamortizations];
    this.terms = [...this.props.selection.loanterms];

    /* unit test!
                let l = ChosenLoan.fromJson(this.props.selection.selectedloan)
                l.hash = "ho ho ho" 
                this.props.updateSelectField(l, "selectedloan") 
        */
  }
  reset = () => {
    let termselected = [];
    let typeselected = [];
    this.props.updateSelectField(this.terms, "loanterms");
    this.props.updateSelectField(this.amortizations, "loanamortizations");

    this.getTermOptions().forEach((term) => {
      if (this.terms.includes("year" + term.value))
        termselected.push(term.value);
    });
    if (termselected.length === 0) termselected = [this.getTermOptions()[0].value];

    typeoptions.forEach((typ) => {
      if (this.amortizations.includes(typ.value)) typeselected.push(typ);
    });
    if (typeselected.length === 0)
      typeselected = ['all']; // typeoptions.map((x) => x.value);

    this.setState({ termselected, typeselected }, () => {
      this.processProducts(this.rawproducts);
      this.forceUpdate();
    });
  };
  getDTI = getDTI.bind(this);
  getCitizenship = getCitizenship.bind(this);
  getOccupancy = getOccupancy.bind(this);
  getPropertyType = getPropertyType.bind(this);
  productReload = productReload.bind(this);
  getLTV = getLTV.bind(this);

  getFeeConfig = () => {
    if(!this.props.borrowerid) {
        return;
    }
    let token = sessionStorage.getItem("ZeitroA")
    fetch('/data/getFees', {
        method: 'POST',
        headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
            "Content-Type": "application/json",
            "X-Borrower": this.props.borrowerid,
        },
    }).then(
        response => {
            if (response.status !== 200) {

                this.setState({
                    loading: false
                })
                return;
            }
            response.json().then(_fees => {

                let f = new fees(_fees)
                f.cannotshopservices = _fees.cannotshopservices
                f.canshopservices = _fees.canshopservices
                f.closingcostsfinanced = _fees.closingcostsfinanced
                f.deposit = _fees.deposit
                f.downpayment = _fees.downpayment
                f.fundsforborrower = _fees.fundsforborrower
                f.initialescrowpaymentsatclosing = _fees.initialescrowpaymentsatclosing
                f.othercosts = _fees.othercosts
                f.prepaids = _fees.prepaids
                f.recordingandgovernmentfees = _fees.recordingandgovernmentfees
                f.transfertax = _fees.transfertax
                f.sellerscredits = _fees.sellerscredits
                f.adjustmentsothercredits = _fees.adjustmentsothercredits
                this.props.updateSelectField(f, "estimatedclosingcosts")
                getCurrentState()
            })
        }

    ).catch((err) => {

        this.setState({ loading: false })
    });
  }
  compareRate = (a, b) => {
    if (a.base_rate !== b.base_rate) return a.base_rate - b.base_rate;

    return a.closing_cost - b.closing_cost; // take into account remaining credits
  };

  cullRate = (products) => {
    if (products.length === 0) return products;

    let newproducts = [];
    newproducts.push(products[0]);
    let base_rate = products[0].base_rate;
    let counter = 0;
    for (let i = 1; i < products.length; i++) {
      if (products[i].base_rate !== base_rate) {
        newproducts.push(products[i]);
        base_rate = products[i].base_rate;
        counter = 1;
      } else {
        counter += 1;
        if (counter < 5) {
          newproducts.push(products[i]);
          base_rate = products[i].base_rate;
        }
      }
    }
    return newproducts;
  };
  compareAPR = (a, b) => {
    if (a.APR !== b.APR) return a.APR - b.APR;
    if (a.base_rate !== b.base_rate) return a.base_rate - b.base_rate;
    return a.closing_cost - b.closing_cost;
  };
  cullAPR = (products) => {
    if (products.length === 0) return products;
    let newproducts = [];
    newproducts.push(products[0]);
    let APR = products[0].APR;
    for (let i = 1; i < products.length; i++) {
      if (products[i].APR !== APR) {
        newproducts.push(products[i]);
        APR = products[i].APR;
      } else {
      }
    }
    return newproducts;
  };
  compareMoneyUpfront = (a, b) => {
    let acc = this.getClosingCosts(a);
    let bcc = this.getClosingCosts(b);
    if (acc !== bcc) return acc - bcc;
    return a.base_rate - b.base_rate;
  };

  cullMoneyUpfront = (products) => {
    if (products.length === 0) return products;

    let newproducts = [];
    newproducts.push(products[0]);
    let closing_cost = this.getClosingCosts(products[0]);
    for (let i = 1; i < products.length; i++) {
      if (this.getClosingCosts(products[i]) !== closing_cost) {
        newproducts.push(products[i]);
        closing_cost = this.getClosingCosts(products[i]);
      } else {
      }
    }
    return newproducts;
  };

  compareMonthly = (a, b) => {
    if (a.monthly_payment !== b.monthly_payment)
      return a.monthly_payment - b.monthly_payment;
    return a.closing_cost - b.closing_cost;
  };

  cullMonthly = (products) => {
    if (products.length === 0) return products;

    let newproducts = [];
    newproducts.push(products[0]);
    let monthly_payment = products[0].monthly_payment;
    for (let i = 1; i < products.length; i++) {
      if (products[i].monthly_payment !== monthly_payment) {
        newproducts.push(products[i]);
        monthly_payment = products[i].monthly_payment;
      } else {
      }
    }
    return newproducts;
  };
  compareTotalOwnership = (a, b) => {
    let loansize = com.safeParseInt(this.state.loansize);
    let ca = com.getClosedInterestPaid(
      0.01 * a.base_rate,
      loansize,
      a.Term,
      a.Term
    ); //+ a.closing_cost
    let cb = com.getClosedInterestPaid(
      0.01 * b.base_rate,
      loansize,
      b.Term,
      b.Term
    ); //+  b.closing_cost

    if (ca !== cb) return ca - cb;

    return a.base_rate - b.base_rate;
  };
  cullTotalOwnership = (products) => {
    if (products.length === 0) return products;

    let getCost = (a) => {
      let loansize = com.safeParseInt(this.state.loansize);
      return com.getClosedInterestPaid(
        0.01 * a.base_rate,
        loansize,
        a.Term,
        a.Term
      ); //+ a.closing_cost
    };
    let newproducts = [];
    newproducts.push(products[0]);
    let cost = getCost(products[0]);

    for (let i = 1; i < products.length; i++) {
      if (cost !== getCost(products[i])) {
        newproducts.push(products[i]);
        cost = getCost(products[i]);
      } else {
      }
    }
    return newproducts;
  };

  compareHoldingOwnership = (a, b) => {
    let loansize = com.safeParseInt(this.state.loansize);
    let ca = com.getClosedInterestPaid(
      0.01 * a.base_rate,
      loansize,
      a.Term,
      this.state.yearstohold
    ); // + a.closing_cost
    let cb = com.getClosedInterestPaid(
      0.01 * b.base_rate,
      loansize,
      b.Term,
      this.state.yearstohold
    ); // +  b.closing_cost

    if (ca !== cb) return ca - cb;

    return a.base_rate - b.base_rate;
  };

  cullHoldingOwnership = (products) => {
    if (products.length === 0) return products;

    let getCost = (a) => {
      let loansize = com.safeParseInt(this.state.loansize);
      return (
        com.getClosedInterestPaid(
          0.01 * a.base_rate,
          loansize,
          a.Term,
          this.state.yearstohold
        ) + a.closing_cost
      );
    };
    let newproducts = [];
    newproducts.push(products[0]);
    let cost = getCost(products[0]);

    for (let i = 1; i < products.length; i++) {
      if (cost !== getCost(products[i])) {
        newproducts.push(products[i]);
        cost = getCost(products[i]);
      } else {
      }
    }
    return newproducts;
  };

  askedForAssistance = () => {
    return (
      true === this.props.application.askedforassistance &&
      this.props.application.property.purpose === "purchase"
    );
  };
  componentDidMount() {
    // console.log("--------------------------------render ProductFilterModal");
    this.handleScroll();
    if (this.filtersWrapRef.current) {
      this.resizeObserver = new ResizeObserver(() => {
        this.handleScroll();
      });
      this.resizeObserver.observe(this.filtersWrapRef.current);
    }
    if (
      this.props.property.purpose !== "purchase" &&
      this.props.property.purpose !== "cashoutrefinance" &&
      this.props.property.purpose !== "refinance"
    ) {
      this.showModal();
    }
  }
  componentWillUnmount() {
    // console.log('ProductFilterModal componentWillUnmount called')
    if (this.resizeObserver && this.filtersWrapRef.current) {
      this.resizeObserver.unobserve(this.filtersWrapRef.current);
      this.resizeObserver.disconnect();
    }
  }

  filterForAssistance = (products) => {
    let out = [];
    products.forEach((x) => {
      if (["RocketPro", "Plaza"].includes(x.Lender)) {
        out.push(x);
      }
    });
    return out;
  };

  updateLender = (lender) => {
    let found = false;
    this.lenders.forEach((x) => {
      if (x === lender) {
        found = true;
      }
    });
    if (found) return;
    this.lenders.push(lender);
    this.setState({ selectedlenders: ['all'] // this.lenders
      , lenders: this.lenders });
  };
  updateMtype = (mtype) => {
    let foundmtype = false;
    this.mtypes.forEach((x) => {
      if (x === mtype) {
        foundmtype = true;
      }
    });
    if (foundmtype) return;
    this.mtypes.push(mtype);

    this.setState({ selectedmtypes: ['all'] // this.mtypes,
      , mtypes: this.mtypes });
  };
  updateIncomeDocType = (incomedoctypes) => {
    const newIncomeDocTypes = incomedoctypes.filter(
      (type) => !this.incomedoctypes.includes(type)
    );
    if (newIncomeDocTypes.length === 0) {
      return;
    }
    this.incomedoctypes = [
      ...new Set([...this.incomedoctypes, ...newIncomeDocTypes]),
    ];
    this.setState({
      selectedincomedoctypes:  ['all'], // this.incomedoctypes,
      incomedoctypes: this.incomedoctypes,
    });
  };
  isUncheckedLender = (lender) => {
    if (this.state.selectedlenders.includes('all')) {
      return false; // 如果选择了 'all', 则没有未选中的
    }
    let foundlender = false;
    this.state.selectedlenders.forEach((x) => {
      if (x === lender) {
        foundlender = true;
      }
    });
    return !foundlender;
  };
  isUncheckedMtype = (mtype) => {
    if (this.state.selectedmtypes.includes('all')) {
      return false; // 如果选择了 'all', 则没有未选中的
    }
    let foundmtype = false;
    this.state.selectedmtypes.forEach((x) => {
      if (x === mtype) {
        foundmtype = true;
      }
    });
    return !foundmtype;
  };
  isUncheckedIncomeDocType = (incomedoctypes) => {
    if (this.state.selectedincomedoctypes.includes('all')) {
      return false; // 如果选择了 'all', 则没有未选中的
    }
    // 确保 incomedoctypes 是一个数组
    const typesToCheck = Array.isArray(incomedoctypes) ? incomedoctypes : [incomedoctypes];
    return !typesToCheck.some((docType) =>
      this.state.selectedincomedoctypes.includes(docType)
    );
  };
  processProducts = (products) => {
    if ("undefined" === typeof products || products.length === 0) return;
    this.rawproducts = products;
    let rearranged = [];

    let mintotalinterest = 100000000;
    let maxtotalinterest = 0;
    let maxreserves = 0;
    let _types = this.state.typeselected.includes('all') ? typeoptions.map(x => x.value) : [...this.state.typeselected];
    let _terms = this.state.termselected.includes('all') ? this.getTermOptions().map(x => x.value) : [...this.state.termselected];
    let _totalterms = [];
    products.forEach((product) => {
      let lender = product.Lender;
      this.updateLender(lender);
      if (this.isUncheckedLender(lender)) return;
      product.ProductRatesCosts.forEach((pr) => {
        let commonproduct = pr.product;
        let ausengine = pr.AUSEngine;
        let mtype = pr.product.Mtype;
        if (this.props.application.borrower.declarations.servearmedforces !== "yes" && mtype === "VA")  {
          return
        }
        this.updateMtype(mtype);
        if (this.isUncheckedMtype(mtype)) return;
        this.updateIncomeDocType(commonproduct.IncomeDocTypes);
        if (this.isUncheckedIncomeDocType(commonproduct.IncomeDocTypes)) return;
        pr.rateCosts.forEach((rate) => {
          if (!_totalterms.includes(com.safeParseInt(commonproduct.Term))) {
            _totalterms.push(com.safeParseInt(commonproduct.Term));
          }

          if (_terms.includes(com.safeParseInt(commonproduct.Term))) {
            let typ = commonproduct.Arm;
            // console.log('processProducts typ', typ)
            if (typ === null || typeof typ === "undefined") typ = "fixed";
            else typ = "arm" + typ.fixedperiod + "6";
            // filter out non-30 day locks
            if (rate.lockDay !== 30) return;

            if (_types.includes(typ)) {
              let cc = rate.closing_cost; // + rate.prepaid_interest
              let interest = com.getClosedInterestPaid(
                0.01 * rate.base_rate,
                com.safeParseInt(this.state.loansize),
                commonproduct.Term,
                this.state.yearstohold
              );

              if (interest > maxtotalinterest) maxtotalinterest = interest;
              if (interest < mintotalinterest) mintotalinterest = interest;
              if (rate.min_months_reserves > maxreserves)
                maxreserves = rate.min_months_reserves;
            } else {
            }
          } else {
          }
          let pdkt = {
            Lender: lender,
            ...commonproduct,
            Aus: ausengine,
            ...rate,
          };

          rearranged.push(pdkt);
        });
      });
    });

    this.setState({ maxreserves });

    if (
      this.state.selectedmaxreserves < 0 ||
      this.state.selectedmaxreserves > maxreserves
    ) {
      this.setState({ selectedmaxreserves: maxreserves });
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.selectedmaxreserves = maxreserves;
    }

    

    // 更新本地状态
    this.setState({
      mintotalinterest: mintotalinterest,
      maxtotalinterest: maxtotalinterest,
    });

    let terms = [];
    rearranged.forEach((pr) => {
      let term = pr.Arm ? pr.Arm.fixedperiod : "fixed";
      if (!terms.includes(term)) terms.push(term);
    });

    // Lender, Name
    let plainproducts = [];
    this.referi = {};
    rearranged.forEach((pr) => {
      if (pr.lockDay !== 30) return;

      const {
        Lender,
        Name,
        Aus,
        lenderinfo,
        features,
        DTI,
        high_cost_loan,
        high_priced_loan,
        ...partialObject
      } = pr;

      let hsh = hash(partialObject);
      if (typeof this.referi[hsh] === "undefined") {
        plainproducts.push({ hash: hsh, ...partialObject });
        this.referi[hsh] = [
          {
            Lender: Lender,
            Name: Name,
            Aus: Aus,
            LenderInfo: lenderinfo,
            Rate: partialObject,
          },
        ];
      } else {
        this.referi[hsh].push({
          Lender: Lender,
          Name: Name,
          Aus: Aus,
          LenderInfo: lenderinfo,
          Rate: partialObject,
        });
      }
    });

    this.products = plainproducts;
    this.filter();

    // this.getSelectedIcon(this.props.selection.selectedloan);
    // if (!this.changeshown) {
    //   if (
    //     this.props.application.selection.selectedloan == null ||
    //     this.props.application.selection.selectedloan.hash === ""
    //   ) {
    //   } else {
    //     if (
    //       this.referi[this.props.application.selection.selectedloan.hash] ==
    //       null
    //     ) {
    //       let suggestedLoan = this.findClosestLoan();
    //       this.setState({ showPriceChanged: true, suggestedLoan });
    //     }
    //   }
    //   this.changeshown = true;
    // }
  };
  getSelectedIcon = (selectedloan) => {
    // prep the logo for the selected loan
    if (selectedloan != null && selectedloan.hash !== "") {
      let lenders = this.referi[selectedloan.hash];

      if (lenders != null) {
        let lender = lenders[0];

        let src = "/loan.png";
        let image = (
          <img
            alt="lender"
            height={24}
            style={{ height: "24", width: "auto" }}
            className="mr-2"
            src={src}
          ></img>
        );
        this.setState({ selectedImage: image, needsAdjustment: false });
      } else {
        if (selectedloan.loansize !== this.state.loansize) {
          // keep old
        } else {
          let src = "/pricingchange.png";
          let image = (
            <Link onClick={this.onPriceChange}>
              <img
                alt="ho ho ho"
                height={24}
                style={{ height: "24", width: "auto" }}
                className="mr-2 oscillate"
                src={src}
              ></img>{" "}
            </Link>
          );
          this.setState({ selectedImage: image, needsAdjustment: true });
        }
      }
    } else {
      let src = "/pricingchange.png";
      let image = (
        <Link onClick={this.onPriceChange}>
          <img
            alt="ho ho ho"
            height={24}
            style={{ height: "24", width: "auto" }}
            className="mr-2 oscillate"
            src={src}
          ></img>{" "}
        </Link>
      );
      this.setState({ selectedImage: image, needsAdjustment: true });
    }
  };
  findClosestLoan = () => {
    let loan = this.props.selection.selectedloan;
    let nextbest = null;
    if (this.products.length === 0) {
      return;
    }
    this.products.forEach((p) => {
      if (p.base_rate !== loan.base_rate) return;
      if (p.Term !== loan.Term) return;
      if (loan.ARM != null) {
        if (p.ARM == null) return;
        if (loan.ARM.fixedperiod !== p.ARM.fixedperiod) return;
      }
      if (nextbest == null) {
        nextbest = p;
        return;
      }
      if (nextbest.closing_cost < 0 && p.closing_cost > 0) return;
      if (nextbest.closing_cost < 0 && p.closing_cost < 0) {
        if (nextbest.closing_cost > p.closing_cost) {
          nextbest = p;
          return;
        }
      } else {
        if (nextbest.closing_cost > 0 && p.closing_cost > 0) {
          if (nextbest.closing_cost > p.closing_cost) {
            nextbest = p;
            return;
          }
        } else {
          if (nextbest.closing_cost > 0 && p.closing_cost <= 0) {
            nextbest = p;
            return;
          }
        }
      }
    });

    let suggested = new ChosenLoan();
    suggested.hash = nextbest.hash;

    suggested.APR = nextbest.APR;
    if (nextbest.Arm !== null) suggested.Arm = nextbest.Arm;
    suggested.amortization = nextbest.MortgageAmortization;
    suggested.Mtype = nextbest.Mtype;
    suggested.Term = nextbest.Term;
    suggested.base_rate = nextbest.base_rate;
    suggested.closing_cost = nextbest.closing_cost;
    suggested.features = nextbest.features;
    suggested.high_cost_mortgage = nextbest.high_cost_mortgage;
    suggested.lender_credit = nextbest.lender_credit;
    suggested.lender_fee = nextbest.lender_fee;
    suggested.lockDay = nextbest.lockDay;
    suggested.min_months_reserves = nextbest.min_months_reserves;
    suggested.monthly_payment = nextbest.monthly_payment;
    suggested.prepaid_interest = nextbest.prepaid_interest;
    suggested.points = nextbest.points;
    suggested.pmi = nextbest.PMICost;
    suggested.FHAMIP = nextbest.FHAMIP;
    suggested.DTI = nextbest.DTI;
    suggested.matchingproducts = [];
    suggested.loansize = loan.loansize;
    suggested.purpose = this.props.property.purpose;
    suggested.ourfee = nextbest.zeitro_fee;
    suggested.prepaiddays = this.prepaid_interest_days;
    suggested.downpayment = loan.downpayment;
    suggested.paydown = loan.paydown;
    suggested.checkout = loan.checkout;
    suggested.aus = loan.aus;
    suggested.matchingproducts = [];
    if (nextbest.maxcachout != null) suggested.maxcashout = nextbest.maxcashout;

    this.referi[nextbest.hash].forEach((pr) => {
      let l = new LoanProduct();

      l.Lender = pr.Lender;
      l.Name = pr.Name;
      l.lenderinfo = pr.LenderInfo;
      l.aus = pr.Aus;
      suggested.matchingproducts.push(l);
    });
    // suggested.lender = lender2lender[suggested.matchingproducts[0].Lender]
    // preserve edits if they were already made
    if (loan != null && loan.estimatedclosingcosts != null) {
      suggested.estimatedclosingcosts = loan.estimatedclosingcosts;
    } else {
      suggested.estimatedclosingcosts =
        this.props.selection.estimatedclosingcosts;
    }
    return suggested;
  };
  onPriceChange = () => {
    let suggestedLoan = this.findClosestLoan();
    this.setState({ showPriceChanged: true, suggestedLoan });
  };
  filter = () => {
    if (!this.products) return;
    let types = this.state.typeselected.includes('all') ? typeoptions.map(x => x.value) : [...this.state.typeselected];
    let terms = this.state.termselected.includes('all') ? this.getTermOptions().map(x => x.value) : [...this.state.termselected];

    let filteredbyterm = this.products.filter((p) => terms.includes(p.Term));

    let filteredbytype = filteredbyterm.filter((p) => {
      let typ = p.Arm;
      if (typ === null || typeof typ === "undefined") typ = "fixed";
      else typ = "arm" + typ.fixedperiod + "6";
      return types.includes(typ);
    });
    
    
    let top = filteredbytype;

    if (
      this.props.property.purpose === "cashoutrefinance" &&
      this.props.selection.mincashout > 0
    ) {
      if (
        parseInt(this.props.selection.cashout) < this.props.selection.mincashout
      ) {
        this.setState({
          errorText: (
            <div className="mb-4 text-center">
              <h4 className="mt-5">
                Minimum cashout size is $
                {com.commaizeFloat(this.props.selection.mincashout)}.
              </h4>
              <br />
              <div style={{ fontSize: "1.5em" }} className="mb-3">
                Please increase the cashout size
              </div>
            </div>
          ),
          topProducts: [],
        });
        return;
      }
    }

    // 如果有targetprice，则产品按照targetprice排序 排序规则为 越靠近targetprice的数据越靠前
    if(Math.abs(this.state.targetprice) > 0) {
        let sorted_culled = top.sort((a, b) => {
            return Math.abs(a.points - this.state.targetprice) - Math.abs(b.points - this.state.targetprice)
        })
        this.setState({ products:sorted_culled,  topProducts: top })
        // console.log("culled", top, sorted_culled)
    }else{
        this.setState({ products: top,  topProducts: top })
    }

    if(this.products.length === 0) {
      this.setState({
        errorText: (
          <div className="mb-4 text-center">
            <h4 className="mt-5">There are no qualifying loan products that fit your filters.</h4>
          </div>
        ),
      });
    }

    if (
      this.products &&
      this.products.length > 0 &&
      this.state.topProducts.length === 0
    ) {
      this.setState({
        errorText: (
          <div className="mb-4 text-center">
            <h4 className="mt-5">
              There are no qualifying loan products that fit your filters.
            </h4>
            {/* <div style={{ fontSize: '1.5em' }} className="mb-3">Move the range sliders, change the term/amortization selections, or</div>
                    <Button onClick={this.resetDefault} > <div style={{ fontSize: '1.4em' }}>Click to reset filters to default </div></Button>  */}
          </div>
        ),
      });
    }
  };

  resetDefault = () => {
    let termselected = [this.getTermOptions()[0].value];

    let typeselected = [];
    typeoptions.forEach((typ) => {
      typeselected.push(typ.value);
    });
    this.setState({ typeselected: ['all'], termselected });

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.processProducts(this.rawproducts);
      this.forceUpdate();
    }, 1000);
  };
  renderProducts = () => {
    return this.state.topProducts.map(this.displayCard);
  };
  onTriangleUpdate = (l1, l2) => {
    l1 = parseFloat(l1);
    l2 = parseFloat(l2);
    this.setState({
      weightclosing: l2,
      weighttotalcost: l1,
      weightmonthly: Math.max(0.0, 1 - l2 - l1),
    });

    this.props.updateSelectField(l2, "weightclosing");
    this.props.updateSelectField(l1, "weighttotalcost");
    this.props.updateSelectField(Math.max(0.0, 1 - l2 - l1), "weightmonthly");

    this.filter();
  };

  updateTerms = (e) => {
    let out = [];
    e.forEach((t) => {
      out.push(t.id);
    });
    this.props.updateSelectField(out, "loanterms");
  };
  onDeselectAmortization = (e) => {
    if (e === 'all') {
      this.onSelect([]);
    }else{
      this.onSelect(this.state.typeselected.filter(x => x !== e));
    }
  }
  onSelectAmortization = (e) => {
    if (e === 'all') {
      this.onSelect(['all']);
    } else {
      if(this.state.typeselected.includes('all')) {
        this.onSelect([...this.state.typeselected.filter(x => x !== 'all'), e])
      } else {
        this.state.typeselected.length + 1 === typeoptions.length ? this.onSelect(['all']) : this.onSelect([e, ...this.state.typeselected]);
      }
    }
  }
  onSelect = (e) => {
    this.state.typeselected = e;
    this.setState({ typeselected: e, isEditFilter: true });
    this.props.updateSelectField(e.includes('all') ? e.filter(x => x !== 'all') : e, "loanamortizations");
    this.processProducts(this.rawproducts);
    this.clearSelected();
    this.forceUpdate();
  };

  onSelectTermsWithAll = (value) => {
    if (value === 'all') {
      this.onSelectTerms(['all']);
    } else {
      const currentSelection = this.state.termselected;
      if (currentSelection.includes('all')) {
        this.onSelectTerms([value]);
      } else {
        const newSelection = [...currentSelection, value];
        if (newSelection.length === this.getTermOptions().length) {
          this.onSelectTerms(['all']);
        } else {
          this.onSelectTerms(newSelection);
        }
      }
    }
  };

  onDeselectTermsWithAll = (value) => {
    if (value === 'all') {
      this.onSelectTerms([]);
    } else {
      const currentSelection = this.state.termselected;
      if (currentSelection.includes('all')) {
        const newSelection = this.getTermOptions().map(opt => opt.value).filter(optValue => optValue !== value);
        this.onSelectTerms(newSelection);
      } else {
        const newSelection = currentSelection.filter(item => item !== value);
        this.onSelectTerms(newSelection);
      }
    }
  };

  onSelectLendersWithAll = (value) => {
    if (value === 'all') {
      this.onSelectLenders(['all']);
    } else {
      const currentSelection = this.state.selectedlenders;
      if (currentSelection.includes('all')) {
        this.onSelectLenders([value]);
      } else {
        const newSelection = [...currentSelection, value];
        // Check against the dynamically populated lenders list
        if (this.state.lenders && newSelection.length === this.state.lenders.length) {
          this.onSelectLenders(['all']);
        } else {
          this.onSelectLenders(newSelection);
        }
      }
    }
  };

  onDeselectLendersWithAll = (value) => {
    if (value === 'all') {
      this.onSelectLenders([]);
    } else {
      const currentSelection = this.state.selectedlenders;
      if (currentSelection.includes('all')) {
        // Use the dynamically populated lenders list
        const allLenders = this.state.lenders || [];
        const newSelection = allLenders.filter(lender => lender !== value);
        this.onSelectLenders(newSelection);
      } else {
        const newSelection = currentSelection.filter(item => item !== value);
        this.onSelectLenders(newSelection);
      }
    }
  };

  onSelectMortgageTypesWithAll = (value) => {
    if (value === 'all') {
      this.onSelectMortgageTypes(['all']);
    } else {
      const currentSelection = this.state.selectedmtypes;
      if (currentSelection.includes('all')) {
        this.onSelectMortgageTypes([value]);
      } else {
        const newSelection = [...currentSelection, value];
        // Check against the dynamically populated mtypes list
        if (this.state.mtypes && newSelection.length === this.state.mtypes.length) {
          this.onSelectMortgageTypes(['all']);
        } else {
          this.onSelectMortgageTypes(newSelection);
        }
      }
    }
  };

  onDeselectMortgageTypesWithAll = (value) => {
    if (value === 'all') {
      this.onSelectMortgageTypes([]);
    } else {
      const currentSelection = this.state.selectedmtypes;
      if (currentSelection.includes('all')) {
        // Use the dynamically populated mtypes list
        const allMtypes = this.state.mtypes || [];
        const newSelection = allMtypes.filter(mtype => mtype !== value);
        this.onSelectMortgageTypes(newSelection);
      } else {
        const newSelection = currentSelection.filter(item => item !== value);
        this.onSelectMortgageTypes(newSelection);
      }
    }
  };

  onSelectIncomeDocTypesWithAll = (value) => {
    if (value === 'all') {
      this.onSelectIncomeDocTypes(['all']);
    } else {
      const currentSelection = this.state.selectedincomedoctypes;
      if (currentSelection.includes('all')) {
        this.onSelectIncomeDocTypes([value]);
      } else {
        const newSelection = [...currentSelection, value];
        // Check against the dynamically populated incomedoctypes list
        if (this.state.incomedoctypes && newSelection.length === this.state.incomedoctypes.length) {
          this.onSelectIncomeDocTypes(['all']);
        } else {
          this.onSelectIncomeDocTypes(newSelection);
        }
      }
    }
  };

  onDeselectIncomeDocTypesWithAll = (value) => {
    if (value === 'all') {
      this.onSelectIncomeDocTypes([]);
    } else {
      const currentSelection = this.state.selectedincomedoctypes;
      if (currentSelection.includes('all')) {
        // Use the dynamically populated incomedoctypes list
        const allIncomeDocTypes = this.state.incomedoctypes || [];
        const newSelection = allIncomeDocTypes.filter(docType => docType !== value);
        this.onSelectIncomeDocTypes(newSelection);
      } else {
        const newSelection = currentSelection.filter(item => item !== value);
        this.onSelectIncomeDocTypes(newSelection);
      }
    }
  };
  onSelectTerms = (e) => {
    this.state.termselected = e;
    this.setState({ termselected: e, isEditFilter: true });
    this.props.updateSelectField(
      e.map((x) => "year" + x),
      "loanterms"
    );
    this.processProducts(this.rawproducts);
    this.clearSelected();
    this.forceUpdate();
  };
  onSelectTargetPrice = (e) => {
    // 设置targetprice时清除排序状态
    this.setState({ targetprice: e, sortOrder: null, sortColumn: null }, () => {
        this.processProducts(this.rawproducts)
        this.clearSelected()
        this.forceUpdate()
    })
  }
  onSelectMortgageTypes = (e) => {
    this.setState({ selectedmtypes: e, isEditFilter: true }, () => {
      // this.updateTerms(e)
      this.processProducts(this.rawproducts);
      this.forceUpdate();
    });
  };
  onSelectIncomeDocTypes = (e) => {
    this.setState({ selectedincomedoctypes: e, isEditFilter: true }, () => {
      this.processProducts(this.rawproducts);
      this.clearSelected();
      this.forceUpdate();
    });
  };
  onSelectLenders = (e) => {
    this.setState({ selectedlenders: e, isEditFilter: true }, () => {
      this.updateTerms(e);
      this.processProducts(this.rawproducts);
      this.clearSelected();
      this.forceUpdate();
    });
  };

  selectsort = (e) => {
    this.props.updateSelectField(e, "sortby");
    switch (e) {
      case "selectbyrate":
        this.compare = this.compareRate;
        this.cull = this.cullRate;
        break;
      case "selectbyapr":
        this.compare = this.compareAPR;
        this.cull = this.cullAPR;
        break;
      case "selectbyinterestterm":
        this.compare = this.compareHoldingOwnership;
        this.cull = this.cullHoldingOwnership;
        break;
      case "selectbyinteresttotal":
        this.compare = this.compareTotalOwnership;
        this.cull = this.cullTotalOwnership;
        break;
      case "selectbymonthlypayment":
        this.compare = this.compareMonthly;
        this.cull = this.cullMonthly;
        break;
      case "selectbyclosingcosts":
        this.compare = this.compareMoneyUpfront;
        this.cull = this.cullMoneyUpfront;
        break;

      default:
        break;
    }
    this.filter();
    return;
  };

  changeYears = (e) => {
    this.setState({ yearstohold: e });
    this.props.updateApplicationAttribute(
      com.safeParseInt(e),
      "keepinghousefor"
    );
    return false;
  };
  //--- begin callbacks that cause a reload
  updateDownpayment = (e) => {
    let dp = e;
    if (isNaN(dp)) return;
    this.setState({ downpayment: com.safeParseInt(dp) });
    return false;
  };
  changeDownpayment = (e) => {
    const dp = e ?? 0;
    if (isNaN(dp)) return;
    let ls = this.state.propertyvalue - parseFloat(dp);
    this.setState({
      downpayment: dp,
      loansize: ls,
      ltv: (100 * ls) / this.state.propertyvalue,
      defdownpayment: dp,
    });
  };

  changePaydown = (e) => {
    let dp = e ?? 0;
    if (isNaN(dp)) dp = 0;

    // 对于再融资类型，贷款金额 = 贷款余额 - 还款金额
    let ls = com.safeParseInt(this.state.currentbalance) - parseFloat(dp);
    
    // 更新本地状态
    this.setState({
      downpayment: com.safeParseInt(dp),
      loansize: ls,
      defdownpayment: dp,
      ltv: (100 * ls) / this.state.propertyvalue // 使用salesprice而非property.appraisal，保持与ProductPicker一致
    });
    return false;
  };

  changeCashout = (e) => {
    let dp = e ?? 0;

    // 对于提取现金再融资类型，贷款金额 = 贷款余额 + 提取金额
    let ls = com.safeParseInt(this.state.currentbalance) + parseFloat(dp);
    
    // 更新本地状态
    this.setState({ 
      downpayment: dp, 
      loansize: ls, 
      defdownpayment: dp,
      ltv: (100 * ls) / this.state.propertyvalue // 使用salesprice而非property.appraisal，保持与ProductPicker一致
    });
    return false;
  };

  changeIncome = e => {
    let dp = e ?? 0
    if (isNaN(dp))
        dp = 0
    this.setState({ income: dp })
  }
  changeLiabilities = e => {
      let dp = e ?? 0
      if (isNaN(dp))
          dp = 0
      this.setState({ liabilities: dp })
  }
  changeFico = (e) => {
    let dp = e ?? 0;
    this.setState({ fico: dp })
  }
  changePropertyValue = e => {
    let dp = e ?? 0
    if (isNaN(dp))
        dp = 0
    if (this.props.application.property.purpose === "purchase") {
        // Use the down payment typed here, not the 1003 one, so editing both fields in either order agrees.
        let downpayment = com.safeParseInt(this.state.defdownpayment)
        let newLoansize = dp - downpayment
        if (newLoansize >= 0) {
            this.setState({ loansize: newLoansize, ltv: dp > 0 ? (100 * newLoansize) / dp : 0 })
        }
    }
    this.setState({ propertyvalue: dp })
  }
  changeCurrentBalance = e => {
    let dp = e ?? 0
    if (isNaN(dp))
        dp = 0
    let newLoansize = 0
    let defdownpayment = this.state.defdownpayment
    if (this.props.property.purpose === 'refinance') {
        // Keep paydown within the new balance so Update cannot write a negative loansize.
        if (defdownpayment > dp) defdownpayment = Math.max(0, dp)
        newLoansize = Math.max(0, dp - defdownpayment)
    } else if (this.props.property.purpose === 'cashoutrefinance') {
        newLoansize = dp + defdownpayment
    }
    this.setState({ currentbalance: dp, loansize: newLoansize, downpayment: defdownpayment, defdownpayment })
  }
  changePropertyState = e => {
      this.setState({ propertystate: e, propertycounty: '' })
  }
  changePropertyCounty = e => {
      this.setState({ propertycounty: e })
  }
  updateReserves = (e) => {
    let [reserves] = e;
    if (this.state.selectedmaxreserves < 0) return;
    if (isNaN(reserves)) reserves = this.state.maxreserves;
    if (reserves !== this.state.selectedmaxreserves) {
      this.setState({ selectedmaxreserves: reserves });
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.selectedmaxreserves = reserves;
    }

    this.filter();
  };
  changeReserves = (e) => {
    let [reserves] = e;
    if (this.state.selectedmaxreserves < 0) return;
    if (isNaN(reserves)) reserves = this.state.maxreserves;
    if (reserves !== this.state.selectedmaxreserves) {
      this.setState({ selectedmaxreserves: reserves });
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.selectedmaxreserves = reserves;
    }

    this.filter();
  };

  removeSelection(hash) {
    let comparisonSelections = this.state.comparisonSelections;
    delete comparisonSelections[hash];

    this.setState({ comparisonSelections });
  }
  selectLoan(hash) {
    let ob = this.referi[hash][0];
    let loan = new ChosenLoan();
    loan.hash = hash;

    loan.APR = ob.Rate.APR;
    if (ob.Rate.Arm !== null) loan.Arm = ob.Rate.Arm;
    loan.amortization = ob.Rate.MortgageAmortization;
    loan.Mtype = ob.Rate.Mtype;
    loan.Term = ob.Rate.Term;
    loan.base_rate = ob.Rate.base_rate;
    loan.closing_cost = ob.Rate.closing_cost;
    loan.features = ob.Rate.features;
    loan.high_cost_mortgage = ob.Rate.high_cost_mortgage;
    loan.lender_credit = ob.Rate.lender_credit;
    loan.lender_fee = ob.Rate.lender_fee;
    loan.lockDay = ob.Rate.lockDay;
    loan.min_months_reserves = ob.Rate.min_months_reserves;
    loan.monthly_payment = ob.Rate.monthly_payment;
    loan.prepaid_interest = ob.Rate.prepaid_interest;
    loan.points = ob.Rate.points;
    loan.pmi = ob.Rate.PMICost;
    loan.FHAMIP = ob.Rate.FHAMIP;
    loan.DTI = ob.Rate.DTI;
    loan.matchingproducts = [];
    loan.loansize = this.state.searchParams.loansize;
    loan.purpose = this.props.property.purpose;
    loan.ourfee = this.zeitro_fee;
    loan.prepaiddays = this.prepaid_interest_days;

    if (ob.Rate.max_cashout != null) {
      loan.maxcashout = ob.Rate.max_cashout;
    }
    // preserve edits if they were already made
    if (
      this.props.selection.selectedloan != null &&
      this.props.selection.selectedloan.estimatedclosingcosts != null
    ) {
      loan.estimatedclosingcosts =
        this.props.selection.selectedloan.estimatedclosingcosts;
    } else {
      loan.estimatedclosingcosts = this.props.selection.estimatedclosingcosts;
    }
    let cc = loan.estimatedclosingcosts;
    if (loan.FHAMIP != null) {
      let addFha = () => {
        let found = false;

        cc.cannotshopservices.forEach((key) => {
          if (key.servicename === com.upfrontMI) {
            key.estimateamount = loan.FHAMIP.upfrontMIP;
            found = true;
          }
        });
        if (!found) {
          let s = new service();
          s.servicename = com.upfrontMI;
          s.estimateamount = loan.FHAMIP.upfrontMIP;
          cc.cannotshopservices.push(s);
        }
      };
      addFha();
    } else {
      for (let i = 0; i < cc.cannotshopservices.length; i++) {
        if (cc.cannotshopservices[i].servicename === com.upfrontMI) {
          cc.cannotshopservices = cc.cannotshopservices.splice(i, 1);
          break;
        }
      }
    }

    switch (this.props.property.purpose) {
      case "purchase":
        loan.downpayment = this.state.searchParams.defdownpayment;
        break;
      case "refinance":
        loan.paydown = this.state.searchParams.defdownpayment;
        break;
      case "cashoutrefinance":
        loan.cashout = this.state.searchParams.defdownpayment;
        break;
      default:
        break;
    }

    loan.aus = ob.Aus;

    this.referi[hash].forEach((pr) => {
      let l = new LoanProduct();

      l.Lender = pr.Lender;
      l.Name = pr.Name;
      l.lenderinfo = pr.LenderInfo;
      l.aus = pr.Aus;
      loan.matchingproducts.push(l);
    });

    if (
      !this.props.application.selection.loSelectedLoans.some(
        (l) => l.hash === loan.hash
      )
    ) {
      this.props.updateSelectField(
        [...this.props.application.selection.loSelectedLoans, loan],
        "loSelectedLoans"
      );
    }
  }
  notifyBorrower() {
    let token = sessionStorage.getItem("ZeitroA");
    const pathSegments = window.location.pathname.split("/");
    const loanid = pathSegments[pathSegments.length - 1];

    fetch("/los/notifyborroweraboutchosenrate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        Cache: "no-cache",
        "X-Borrower": this.props.borrowerid,
        "X-Loan": loanid,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          return;
        }
      })
      .catch((err) => {});
  }

  selectCard = (card) => {
    com.touch();
    this.selectLoan(card.hash);
  };

  getOldInterestRate = () => {
    if (this.props.application.property.purpose !== st.POL_Refinance) return;
    // just scan all the loans for rate
    // first regular loans from credit report
    let rate = 0;
    for (
      let i = 0;
      i < this.props.application.assetsandliabilities.loans.length;
      i++
    ) {
      if (
        this.props.application.assetsandliabilities.loans[i]
          .forsubjectproperty &&
        this.props.application.assetsandliabilities.loans[i].satisfiedupon ===
          "withproceeds"
      ) {
        rate = this.props.application.assetsandliabilities.loans[i].rate;
      }
    }

    if (0 === rate) {
      if (this.props.application.otherliens !== null) {
        for (let i = 0; i < this.props.application.otherliens.length; i++) {
          if (
            this.props.application.otherliens[i].satisfiedupon ===
            "withproceeds"
          ) {
            rate = this.props.application.otherliens[i].rate;
          }
        }
      }
    }
    return rate;
  };
  scrollToLeft = () => {
    if (this.filtersWrapRef.current) {
      this.filtersWrapRef.current.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }
  };
  scrollToRight = () => {
    if (this.filtersWrapRef.current) {
      this.filtersWrapRef.current.scrollTo({
        left: this.filtersWrapRef.current.scrollWidth,
        behavior: "smooth",
      });
    }
  };
  handleScroll = () => {
    // 添加防抖处理
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
    
    this.scrollTimer = setTimeout(() => {
      const container = this.filtersWrapRef.current;
      if (container) {
        const { scrollLeft, scrollWidth, clientWidth } = container;
        const isScrollable = scrollWidth > clientWidth;
        this.setState({
          showLeftButton: isScrollable && scrollLeft > 0,
          showRightButton: isScrollable && scrollLeft + clientWidth < scrollWidth,
        });
      }
    }, 100);
  };
  displayCard = (card, index) => {
    let currentMonthly = com.getMonthlyValue(
      this.props.application.borrower.expenses.currentfirstmortgage,
      this.props.application.borrower.expenses.currentfirstmortgageperiod
    );
    let mostyle = {};
    if (card.monthly_payment > parseFloat(currentMonthly)) {
      mostyle = { color: "#c33" };
    } else {
      mostyle = { color: "#393" };
    }
    let showSavings = () => {
      if (this.props.property.purpose !== "refinance") return "";
      if (card.monthly_payment > parseFloat(currentMonthly)) {
        return <i className="ml-1 fas fa-arrow-up"></i>;
      }
      return <i className="ml-1 fas fa-arrow-down"></i>;
    };

    if (
      this.props.selection.selectedloan !== null &&
      this.props.selection.selectedloan.hash === card.hash
    )
      return "";
    let getName = () => {
      if (
        this.props.borrowerid &&
        this.referi &&
        this.referi[card.hash] != null
      ) {
        let r = this.referi[card.hash][0];
        return r["Lender"] + ", " + r["Name"];
      }
      return com.capitalize(
        card.Mtype.replace("_", " ").toLowerCase().replace("fha", "FHA")
      );
    };
    let getType = () => {
      let tp = "";
      if (card.Arm == null) tp = "Fixed rate";
      else tp = "ARM " + card.Arm.fixedperiod + "/6";
      return tp;
    };

    let selectCard = (e) => {
      return this.selectCard(card);
    };
    let fingerclass = "fas fa-hand-point-left mr-1";
    if (index === 0) fingerclass += " fingerclass";
    let points = com.commaizeFloat(
      ((card.points * com.safeParseInt(this.state.loansize)) / 100).toFixed(2)
    );
    let moPayment = () => {
      let payment = card.monthly_payment;
      if (card.PMICost !== 0) {
        payment = payment + card.PMICost;
      } else if (card.FHAMIP != null) {
        payment = payment + card.FHAMIP.monthlyMIP;
      }
      payment = com.commaizeFloat(payment.toFixed(2));
      return payment;
    };

    let getBreakPoint = (loan) => {
      let interestRate = this.getOldInterestRate();

      function getClosedInterestPaid(rate, loansize, termmonths, spanmonths) {
        let monthlyrate = rate / 12.0;
        let expn = Math.pow(1 + monthlyrate, termmonths);
        let payment = (loansize * monthlyrate * expn) / (expn - 1);
        payment = Math.round(payment * 100) / 100;

        let accumulatedinterest =
          ((loansize * monthlyrate - payment) *
            (Math.pow(1 + monthlyrate, spanmonths) - 1)) /
            monthlyrate +
          spanmonths * payment;
        return accumulatedinterest;
      }

      let breakPoint = -1;
      if (parseFloat(interestRate) <= loan.base_rate) {
        return breakPoint;
      }

      for (let i = 1; i <= loan.Term * 12; i++) {
        let accumulatedOld = getClosedInterestPaid(
          parseFloat(interestRate) / 100,
          this.state.loansize,
          loan.Term * 12,
          i
        );
        let accumulatedNew = getClosedInterestPaid(
          loan.base_rate / 100,
          this.state.loansize,
          loan.Term * 12,
          i
        );

        accumulatedNew += loan.closing_cost;
        if (accumulatedNew < accumulatedOld) {
          breakPoint = i;
          break;
        }
      }
      return breakPoint;
    };

    return (
      <Container
        key={card.hash}
        className="drop-shadow w-100 px-0 text-left pb-3"
      >
        <Row className="bluishbackground text-left mt-3 mb-0 mx-0 py-2">
          {/* <Col style={{alignItems:"center", paddingRight: '0px' }} xs="auto" className="d-flex text-center vertical-middle mx-0 ">
                        <Form.Group controlId="emailmethod" className="text-center d-block text-nowrap m-0 p-0" >
                            <Form.Check type="checkbox"
                                checked={this.state.comparisonSelections[card.hash] != null}
                                key={card.hash}
                                disabled={this.state.comparisonSelections[card.hash] == null && Object.keys(this.state.comparisonSelections).length >= 4}
                                onChange={oncheckbox}
                                style={{ textAlign: 'center', paddingRight: '0px', paddingLeft: '22px' }}
                                //className="p-0 m-0"
                                label=""
                            ></Form.Check>
                        </Form.Group>
                    </Col> */}
          <Col
            style={{ alignItems: "center", fontWeight: 500 }}
            className="d-flex text-left "
          >
            {getName()}
            {this.props.borrowerid ? (
              ""
            ) : (
              <div>
                , {getType()}, {card.Term} years{" "}
              </div>
            )}
          </Col>
          <Col xs={"auto"} className="text-right align-top loancard">
            <div className="d-flex">
              <Button size="sm" onClick={selectCard} variant="outline">
                <b>Choose rate</b>
              </Button>
              <Button
                size="sm"
                variant="link"
                className="pr-0 ml-0"
                onClick={() => {
                  // eslint-disable-next-line react/no-direct-mutation-state
                  this.state.detailedCard = card;
                  this.setState({ detailedCard: card, show: true });
                }}
              >
                Cost Breakdown
              </Button>
            </div>
          </Col>
        </Row>
        <Row className="text-left mt-0 mb-0 mx-0">
          <Col xs={3} className=" loancard pt-2 ">
            <div>Rate / APR</div>
            <div>
              {card.base_rate}% / {card.APR}%
            </div>
          </Col>
          <Col xs={3} className=" loancard pt-2 ">
            <div>Mo. Payment</div>
            {this.props.property.purpose === "refinance" ? (
              MonhtlyChangeBP(
                currentMonthly,
                card.monthly_payment,
                getBreakPoint(card),
                <span style={mostyle}>
                  <b>${moPayment()}</b>
                  {showSavings()}
                </span>
              )
            ) : (
              <b>${moPayment()}</b>
            )}{" "}
          </Col>
          <Col xs={3} className=" loancard pt-2 ">
            <div>Estimated Closing Cost</div>
            <b>${com.commaizeFloat(this.getClosingCosts(card).toFixed(2))}</b>
          </Col>
          <Col xs={3} className=" loancard pt-2 ">
            <div>Points</div>
            {com.commaizeFloat(card.points.toFixed(3))}%
            {card.points <= 0 ? "" : <span>/${points}</span>}
          </Col>
        </Row>
        <Row className="text-left mt-2 mb-0 mx-0 d-flow">
          <Col className=" d-flow loancard" style={{ color: "#6E6E70" }}>
            {card.PMICost !== 0 ? (
              <span className="mr-3">
                Requires mortgage insurance ${com.commaizeFloat(card.PMICost)}
                /mo
              </span>
            ) : (
              ""
            )}

            {com.safeParseInt(card.min_months_reserves) > 0 ? (
              <span className=" py-2  mr-3">
                Reserves required: {card.min_months_reserves} months
              </span>
            ) : (
              ""
            )}

            {card.FHAMIP != null ? (
              <span className=" py-2  mr-3">
                Upfront mortgage insurance premium: ${card.FHAMIP.upfrontMIP},
                monthly insurance payment: $
                {com.commaizeFloat(card.FHAMIP.monthlyMIP)}
              </span>
            ) : (
              ""
            )}
          </Col>
        </Row>
      </Container>
    );
  };
  // V2 loan pages pass the V2-built DTI application; the Redux copy there is stale.
  dtiSource = () => this.props.dtiApplication || this.props.application
  // Pricing income / debts: the DTI engine's numbers on V2 loans (dtiPricingInputs).
  pricingIncome = () => this.props.dtiPricingInputs
    ? this.props.dtiPricingInputs.income
    : com.safeParseInt(getDTIFromCommon(this.dtiSource(), 'all', 'income'))
  pricingLiabilities = () => this.props.dtiPricingInputs
    ? this.props.dtiPricingInputs.liabilities
    : com.safeParseInt(getDTIFromCommon(this.dtiSource(), 'all', 'liability'))
  resetTo1003Values = () => {
    let propertyvalue = this.props.application.property.purpose === "purchase"
    ? this.props.application.property.salesprice
    : this.props.application.property.appraisal

    let newState = {
      fico: this.props.application.scre,
      propertytype: this.props.application.property.propertytype === "mobilehome" ? "manufacturedhome" : this.props.application.property.propertytype,
      propertyvalue: com.safeParseInt(propertyvalue),
      propertystate: this.props.application.property.state,
      propertycounty: this.props.application.property.county,
      currentbalance: com.safeParseInt(this.props.application.loanbalance),
      firstTimeHomeBuyer: this.props.application.firsttimebuyer,
      income: this.pricingIncome(),
      liabilities: this.pricingLiabilities(),
      showFilterForm: this.state.isEditFilter
    }

    let downpayment, defdownpayment, loansize
    switch (this.props.property.purpose) {
      case "purchase":
        if (this.props.selection.selectedloan.hash !== "") {
          loansize = this.props.selection.loansize
          downpayment = defdownpayment = com.safeParseInt(this.props.property.salesprice) - loansize
        } else {
          downpayment = defdownpayment = com.safeParseInt(this.props.selection.downpayment)
          loansize = com.safeParseInt(this.props.property.salesprice) - downpayment
        }
        this.props.updateSelectField(downpayment, "downpayment")
        break
      case "refinance":
        if (this.props.selection.selectedloan.hash !== "") {
          loansize = this.props.selection.loansize
          downpayment = defdownpayment = com.safeParseInt(this.props.application.loanbalance) - loansize
        } else {
          downpayment = defdownpayment = com.safeParseInt(this.props.selection.paydown)
          loansize = com.safeParseInt(this.props.application.loanbalance) - downpayment
        }
        this.props.updateSelectField(downpayment, "paydown")
        break
      case "cashoutrefinance":
        if (this.props.selection.selectedloan.hash !== "") {
          loansize = this.props.selection.loansize
          downpayment = defdownpayment = loansize - com.safeParseInt(this.props.application.loanbalance)
          if (downpayment <= 0) {
            downpayment = defdownpayment = 30000
          }
        } else {
          downpayment = defdownpayment = com.safeParseInt(this.props.selection.cashout)
          loansize = com.safeParseInt(this.props.application.loanbalance) + downpayment
        }
        this.props.updateSelectField(downpayment, "cashout")
        break
      default:
        break
    }

    Object.assign(newState, { downpayment, defdownpayment, loansize })

    this.setState(newState)
  }
  getLoanSize = () => {
    const { propertyvalue, currentbalance, defdownpayment } = this.state;
    const { purpose } = this.props.property;

    if (purpose === "purchase") {
        // 购房：loansize = propertyvalue - defdownpayment
        return Number(propertyvalue) - Number(defdownpayment);
    } else if (purpose === "refinance") {
        // 重贷：loansize = currentbalance - defdownpayment
        return Number(currentbalance) - Number(defdownpayment);
    } else if (purpose === "cashoutrefinance") {
        // 套现重贷：loansize = currentbalance + defdownpayment
        return Number(currentbalance) + Number(defdownpayment);
    }
    return 0;
  }
  seeRates = () => {
    this.clearSelected()

    const searchParams = {
        propertyvalue: this.state.propertyvalue,
        loansize: this.getLoanSize(),
        defdownpayment: this.state.defdownpayment,
    }
    this.setState({
        errorText: '',
        searchParams: searchParams
    })
    this.getDTI(undefined, this.state.fico)
}
  getLoanLimits = () => {
    fetch("/data/loanlimits")
      .then((res) => {
          if (!res.ok) {
              throw Error(res.statusText)
          }
          return res.json()
      })
      .then((res) => {
          this.setState({ loanLimits: res })
      })
      .catch((err) => {
          console.error(err)
      })
  }
  getCountyOptions = (st) => {
    let options = []
    options.push({value:"", label:"-"})
    let s = st.toUpperCase()
    if (st.length === 2) {
        s = com.convertAbbStateToFull(st).toUpperCase()
    }

    if (s in this.state.loanLimits) {
        let keys = Object.keys(this.state.loanLimits[s])

        keys.forEach((x) => {
            options.push({ value: com.capitalize(x), label: com.capitalize(x) })
        })
    }
    return options
  };

  getStateOptions = () => {
    let options = []
    options.push({value:"",label:"-"})
    let keys = Object.keys(this.state.loanLimits)

    keys.forEach((x) => {
        options.push({
            value: com.capitalize(x),
            label: com.capitalize(x),
        })
    })
    return options
  }
  isSeeRatesDisabled = () => {
    const {
        propertyvalue,
        propertystate,
        propertycounty,
        fico,
        targetprice, 
        defdownpayment,
        income,
        liabilities,
        currentbalance
    } = this.state;

    const { purpose } = this.props.property;

    let defdownpaymentFilled;
    if (purpose === 'refinance' || purpose === 'cashoutrefinance') {
        defdownpaymentFilled = (
            defdownpayment !== null &&
            defdownpayment !== undefined &&
            defdownpayment !== '' &&
            Number(defdownpayment) >= 0
        ); // allow 0, disallow negative
    } else {
        defdownpaymentFilled = Number(defdownpayment) > 0; // must be > 0
    }

    let liabilitiesFilled =
        liabilities !== null &&
        liabilities !== undefined &&
        liabilities !== '' &&
        Number(liabilities) >= 0;

    let allFilled =
        fico &&
        propertyvalue &&
        propertystate &&
        propertycounty &&
        targetprice &&
        defdownpaymentFilled &&
        income &&
        liabilitiesFilled;

    // refinance 或 cashoutrefinance 时校验 currentbalance
    if (purpose === 'refinance' || purpose === 'cashoutrefinance') {
        allFilled = allFilled && currentbalance;
    }

    return !allFilled || this.amountOutOfRange();
  }
  // 将FilterItem组件提取为类方法
  renderFilterItem = ({ title, width, children }) => (
    <div
      style={{ width: width, display: "flex", flexDirection: "column" }}
      className="filter-item"
    >
      <div className="filterTitle">{title}</div>
      <div style={{ marginTop: "8px", width: "100%" }}>{children}</div>
    </div>
  );
  warningIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <rect width="18" height="18" rx="9" fill="#CB8600"/>
            <rect x="8" y="4" width="2" height="7" rx="1" fill="white"/>
            <rect x="10" y="12" width="2" height="2" rx="1" transform="rotate(90 10 12)" fill="white"/>
        </svg>
    )
  }
  selectIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3292 14.6544L21.2686 13.5938L16.673 18.1893L12.0792 13.5956L11.0186 14.6562L15.6123 19.25L15.6117 19.2506L16.6724 20.3113L16.673 20.3107L16.6754 20.3131L17.7361 19.2524L17.7336 19.25L22.3292 14.6544Z" fill="#6E6E70"/>
        </svg>
    )
  }
  // Cash-out beyond the equity (value - balance). Flagged rather than capped with `max`:
  // a cap tied to another field rejects every keystroke while that field is still being typed.
  cashoutOverLimit = () => {
    const limit = com.safeParseInt(this.state.propertyvalue) - com.safeParseInt(this.state.currentbalance)
    return limit > 0 && Number(this.state.defdownpayment) > limit
  }
  // Down payment >= value, paydown > balance or cash-out > equity: no valid loan amount to price.
  amountOutOfRange = () => {
    const purpose = this.props.property.purpose
    const amount = Number(this.state.defdownpayment)
    if (purpose === 'refinance') return amount > Number(this.state.currentbalance)
    if (purpose === 'cashoutrefinance') return this.cashoutOverLimit()
    return amount >= Number(this.state.propertyvalue)
  }
  // Down payment / paydown / cash-out field: empty, or outside what the value or balance allows.
  amountWarning = () => {
    const purchase = !['refinance', 'cashoutrefinance'].includes(this.props.property.purpose)
    return this.isWarning(this.state.defdownpayment, !purchase) || this.amountOutOfRange()
  }
  isWarning = (value, allowZero = false) => {
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    if (allowZero) {
        return value < 0 || value === null || value === undefined || value === "";
    }
    return value <= 0 || value === null || value === undefined || value === "";
  }
  printDownpayment = () => {
    // 创建通用的过滤器组件
    const FilterItem = this.renderFilterItem;

    let filterAmortization = () => {
      return (
        <FilterItem title="Amortization">
          <Select
            multiple
            mode="multiple"
            className="all-rates-select"
            style={{ width: "100%" }}
            status={this.isWarning(this.state.typeselected) ? 'warning' : ''}
            suffixIcon={this.isWarning(this.state.typeselected) ? this.warningIcon() : this.selectIcon()}
            maxTagCount={1}
            maxTagPlaceholder={() => this.state.typeselected.length > 1 ? '+' + (this.state.typeselected.length - 1) : ''}
            maxTagTextLength={8} // 可选：限制标签文本长度
            // onChange={this.onSelectAmortization}
            onDeselect={this.onDeselectAmortization}
            onSelect={this.onSelectAmortization}
            value={this.state.typeselected}
            options={[
              { value: 'all', label: 'All'}, ...typeoptions, 
            ]}
          />
        </FilterItem>
      );
    };
    let filterIncome = () => {
      return (
          <FilterItem title="Income">
              <InputNumber
                  size="middle"
                  style={{width: '100%'}}
                  className="all-rates-input"
                  min={0}
                  controls={false}
                  status={this.isWarning(this.state.income) ? 'warning' : ''}
                  suffix={warningSuffix(this.isWarning(this.state.income), this.warningIcon())}
                  // max={com.safeParseInt(this.props.property.salesprice)}
                  prefix="$"
                  formatter={formatDollars}
                  parser={parseDollars}
                  value={this.state.income}
                  onChange={this.changeIncome}
              />
          </FilterItem>
      )
    }
    let filterLiability = () => {
      return (
        <FilterItem title="Liabilities">
            <InputNumber
                size="middle"
                style={{width: '100%'}}
                className="all-rates-input"
                min={0}
                controls={false}
                status={this.isWarning(this.state.liabilities) ? 'warning' : ''}
                suffix={warningSuffix(this.isWarning(this.state.liabilities), this.warningIcon())}
                // max={com.safeParseInt(this.props.property.salesprice)}
                prefix="$"
                formatter={formatDollars}
                parser={parseDollars}
                value={this.state.liabilities}
                onChange={this.changeLiabilities}
            />
        </FilterItem>
      )
    }
    let filterFirstTimeHomeBuyer = () => {
      return (
          <div style={{height: 48, display: 'flex', alignItems: 'center'}}>
              <Checkbox
                  className='first-time-home-buyer-checkbox'
                  checked={this.state.firstTimeHomeBuyer}
                  onChange={(e) => {
                      this.setState({firstTimeHomeBuyer: e.target.checked, isEditFilter: true})
                  }}
              >
                  First time home buyer?
              </Checkbox>
          </div>
      );
    }
    let filterLoanTerms = () => {
      return (
        <FilterItem title="Loan terms">
          <Select
            multiple
            mode="multiple"
            className="all-rates-select"
            style={{ width: "100%" }}
            status={this.isWarning(this.state.termselected) ? 'warning' : ''}
            suffixIcon={this.isWarning(this.state.termselected) ? this.warningIcon() : this.selectIcon()}
            maxTagCount={1}
            maxTagPlaceholder={() => this.state.termselected.length > 1 ? '+' + (this.state.termselected.length - 1) : ''}
            maxTagTextLength={8} // 可选：限制标签文本长度
            onSelect={this.onSelectTermsWithAll}
            onDeselect={this.onDeselectTermsWithAll}
            value={this.state.termselected}
            options={[
              { value: 'all', label: 'All'}, ...this.getTermOptions() 
            ]}
          />
        </FilterItem>
      );
    };

    let filterLenders = () => {
      return (
        <FilterItem title="Lenders">
          <Select
            multiple
            mode="multiple"
            className="all-rates-select"
            style={{ width: "100%" }}
            status={this.isWarning(this.state.selectedlenders) ? 'warning' : ''}
            suffixIcon={this.isWarning(this.state.selectedlenders) ? this.warningIcon() : this.selectIcon()}
            maxTagCount={1}
            maxTagPlaceholder={() => this.state.selectedlenders.length > 1 ? '+' + (this.state.selectedlenders.length - 1) : ''}
            maxTagTextLength={6} // 可选：限制标签文本长度
            // onChange={this.onSelectLenders}
            onSelect={this.onSelectLendersWithAll}
            onDeselect={this.onDeselectLendersWithAll}
            value={this.state.selectedlenders}
            options={[
              { value: 'all', label: 'All'}, ...this.state.lenders.map((x) => {
                return { value: x, label: com.formatLenderDisplayName(x) };
              })
            ]}
          />
        </FilterItem>
      );
    };
    let filterPropertyType = () => {
      return (
        <FilterItem title="Property type">
            <Select
                className='all-rates-select'
                style={{width:"100%"}}
                value={this.state.propertytype}
                status={this.isWarning(this.state.propertytype) ? 'warning' : ''}
                suffixIcon={this.isWarning(this.state.propertytype) ? this.warningIcon() : this.selectIcon()}
                onChange={(value) => {
                  this.setState({propertytype: value, isEditFilter: true}); 
                  if (value === 'manufacturedhome') {
                      // Remove '30' from termselected if it exists
                      const newTerms = this.state.termselected.filter(term => term !== 30);
                      if (newTerms.length !== this.state.termselected.length) {
                          this.setState({termselected: newTerms});
                          this.onSelectTerms(newTerms);
                      }
                  }
                }}
                options={[
                    {value: "singlefamilydetached", label: "Single Family Home, Detached"},
                    {value: "singlefamilyattached", label: "Single Family Home, Attached"},
                    {value: "condominiumdetached", label: "Condominium, Detached"},
                    {value: "condominium", label: "Condominium, Attached"},
                    {value: "pudattached", label: "Planned Unit Development, attached"},
                    {value: "puddetached", label: "Planned Unit Development, detached"},
                    {value: "twotofourfamily", label: "2 to 4 Unit Multifamily"},
                    {value: "manufacturedhome", label: "Manufactured Home"}
                ]}
            />
        </FilterItem>
      )
    }
    let filterMtypes = () => {
      if (this.props.application.product.mortgageapplied === "nonqm") {
        return (
          <FilterItem title="Doc types">
            <Select
              multiple
              mode="multiple"
              className="all-rates-select"
              style={{ width: "100%" }}
              status={this.isWarning(this.state.selectedincomedoctypes) ? 'warning' : ''}
              suffixIcon={this.isWarning(this.state.selectedincomedoctypes) ? this.warningIcon() : this.selectIcon()}
              maxTagCount={1}
              maxTagPlaceholder={() => this.state.selectedincomedoctypes.length > 1 ? '+' + (this.state.selectedincomedoctypes.length - 1) : ''}
              maxTagTextLength={8} // 可选：限制标签文本长度
              // onChange={this.onSelectIncomeDocTypes}
              onSelect={this.onSelectIncomeDocTypesWithAll}
              onDeselect={this.onDeselectIncomeDocTypesWithAll}
              value={this.state.selectedincomedoctypes}
              options={[
                { value: 'all', label: 'All'}, ...this.state.incomedoctypes.map((x) => {
                  return { value: x, label: com.allIncomeTypes[x] || x };
                })
              ]}
            />
          </FilterItem>
        );
      }

      return (
        <FilterItem title="Loan types">
          <Select
            multiple
            mode="multiple"
            className="all-rates-select"
            style={{ width: "100%" }}
            status={this.isWarning(this.state.selectedmtypes) ? 'warning' : ''}
            suffixIcon={this.isWarning(this.state.selectedmtypes) ? this.warningIcon() : this.selectIcon()}
            maxTagCount={1}
            maxTagPlaceholder={() => this.state.selectedmtypes.length > 1 ? '+' + (this.state.selectedmtypes.length - 1) : ''}
            maxTagTextLength={6}
            onSelect={this.onSelectMortgageTypesWithAll}
            onDeselect={this.onDeselectMortgageTypesWithAll}
            value={this.state.selectedmtypes}
            options={[
              { value: 'all', label: 'All'}, ...this.state.mtypes.map((x) => {
                return { value: x, label: x };
              })
            ]}
          />
        </FilterItem>
      );
    };

    let filterTargetPrice = () => {
      return (
          <FilterItem title="Target point">
              <InputNumber
                  controls={false}
                  size="middle"
                  suffix="%"
                  className="all-rates-input"
                  value={this.state.targetprice}
                  onChange={this.onSelectTargetPrice}
              />
          </FilterItem>
      );
    }
    let propertyValue = () => {
      let propertyvalue = this.props.application.property.purpose === "purchase" ? this.props.application.property.salesprice : this.props.application.property.appraisal
      let updatePropertyValue = () => {
        const purpose = this.props.application.property.purpose
        const verb = purpose === "purchase" ? "salesprice" : "appraisal"
        this.props.changeMainProperty(this.state.propertyvalue, verb)

        if (purpose === "purchase") {
          if (this.state.loansize >= 0) {
              this.props.updateSelectField(this.state.loansize, "loansize")
              this.props.updateSelectedLoanField(this.state.loansize, "loansize")
          }
        }
        const loanId = this.getLoanId()
        if (loanId) {
          const tasks = [patchPropertyFieldsV2(loanId, { [verb]: `${this.state.propertyvalue}` })]
          if (purpose === "purchase" && this.state.loansize >= 0) {
            tasks.push(patchSelectionV2(loanId, { loansize: `${this.state.loansize}` }))
          }
          this.persistUpdateToV2(tasks)
        }
      }
      return (
          <div className='rate-filter-item'>
              <FilterItem title="Property value">
                  <InputNumber
                      size="middle"
                      style={{width: '100%'}}
                      className="all-rates-input"
                      min={0}
                      controls={false}
                      status={this.isWarning(this.state.propertyvalue) ? 'warning' : ''}
                      suffix={warningSuffix(this.isWarning(this.state.propertyvalue), this.warningIcon())}
                      // max={com.safeParseInt(this.props.property.salesprice)}
                      prefix="$"
                      formatter={formatDollars}
                      parser={parseDollars}
                      value={this.state.propertyvalue}
                      onChange={this.changePropertyValue}
                  />
              </FilterItem>
              <div className='rate-filter-item-update'>
                  <div>Current 1003 value:</div>
                  <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(propertyvalue)}</span>. <span className='rate-filter-item-update-btn' onClick={updatePropertyValue}>Update</span></div>
              </div>
          </div>
      )
  }
  let currentBalance = () => {

    let updateCurrentBalance = () => {
      this.props.updateApplicationAttribute(this.state.currentbalance, 'loanbalance')
      this.props.updateSelectField(this.state.loansize, "loansize")
      this.props.updateSelectedLoanField(this.state.loansize, "loansize")
      const purpose = this.props.property.purpose
      const selectionPatch = { loansize: `${this.state.loansize}` }
      if (purpose === "refinance") {
        this.props.updateSelectField(this.state.defdownpayment, "paydown")
        selectionPatch.paydown = `${this.state.defdownpayment}`
      } else if (purpose === "cashoutrefinance") {
        this.props.updateSelectField(this.state.defdownpayment, "cashout")
        selectionPatch.cashout = `${this.state.defdownpayment}`
      }
      const loanId = this.getLoanId()
      if (loanId) {
        this.persistUpdateToV2([
          patchLoanFieldsV2(loanId, { loanbalance: `${this.state.currentbalance}` }),
          patchSelectionV2(loanId, selectionPatch),
        ])
      }
    }
    return (
        <div className='rate-filter-item'>
            <FilterItem title="Current balance">
                <InputNumber
                    size="middle"
                    style={{width: '100%'}}
                    className="all-rates-input"
                    min={0}
                    controls={false}
                    status={this.isWarning(this.state.currentbalance) ? 'warning' : ''}
                    suffix={warningSuffix(this.isWarning(this.state.currentbalance), this.warningIcon())}
                    // max={com.safeParseInt(this.props.property.salesprice)}
                    prefix="$"
                    formatter={formatDollars}
                    parser={parseDollars}
                    value={this.state.currentbalance}
                    onChange={this.changeCurrentBalance}
                />
            </FilterItem>
            <div className='rate-filter-item-update'>
                <div>Current 1003 value:</div>
                <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(this.props.application.loanbalance)}</span>. <span className='rate-filter-item-update-btn' onClick={updateCurrentBalance}>Update</span></div>
            </div>
        </div>
    )
  }
    let propertyState = () => {
      return (
          <FilterItem title="Property state">
              <Select 
                  className='all-rates-select'
                  style={{width:"100%"}}
                  status={this.isWarning(this.state.propertystate) ? 'warning' : ''}
                  suffixIcon={this.isWarning(this.state.propertystate) ? this.warningIcon() : this.selectIcon()}
                  onChange={this.changePropertyState}
                  value={this.state.propertystate}
                  options={this.getStateOptions()}
              />
          </FilterItem>
      )
    }
    let propertyCounty = () => {
        return (
            <FilterItem title="Property county">
                <Select 
                    className='all-rates-select'
                    style={{width:"100%"}}
                    status={this.isWarning(this.state.propertycounty) ? 'warning' : ''}
                    suffixIcon={this.isWarning(this.state.propertycounty) ? this.warningIcon() : this.selectIcon()}
                    onChange={this.changePropertyCounty}
                    value={this.state.propertycounty}
                    options={this.getCountyOptions(this.state.propertystate)}
                />
            </FilterItem>
        )
    }
    let estimatedFICO = () => {
      return (
        <FilterItem title="Est. FICO score">
          <InputNumber
            controls={false}
            status={this.isWarning(this.state.fico) ? 'warning' : ''}
            suffixIcon={this.isWarning(this.state.fico) ? this.warningIcon() : null}
            size="middle"
            className="all-rates-input"
            value={this.state.fico}
            min={500}
            max={1000}
            precision={0}
            onChange={this.changeFico}
          />
        </FilterItem>
      );
    };
    let filterActionBar = () => {
      return <div style={{padding: '0'}} className='rate-filter-action-bar'>
          <div className='reset-to-1003-values' onClick={this.resetTo1003Values}>Reset to 1003 values</div>
          <div className='see-rates-button-wrap'>
              <img src="/images/rate-filter.svg" alt="See rates" onClick={() => this.setState({ showFilterForm: !this.state.showFilterForm })} />
              <Button className='see-rates-button' onClick={this.seeRates} disabled={this.isSeeRatesDisabled()}>See rates</Button>
          </div>
      </div>
    }
    let filterForm = () => {
      return <div className='rate-filter-form'>
          <div style={{padding: '30px 8px 0 0'}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.4475 4.66343C2.64132 4.25805 3.05072 4 3.50005 4H24.5001C24.9359 4 25.3354 4.24294 25.5359 4.62993C25.7364 5.01691 25.7045 5.48339 25.4532 5.83946L18.6667 15.4536V25C18.6667 25.6443 18.1444 26.1667 17.5001 26.1667C16.8557 26.1667 16.3334 25.6443 16.3334 25V15.0833C16.3334 14.8424 16.408 14.6074 16.5469 14.4105L22.2485 6.33333H5.9402L12.4081 14.3508C12.5754 14.5583 12.6667 14.8168 12.6667 15.0833V22.025C12.6667 22.6693 12.1444 23.1917 11.5001 23.1917C10.8557 23.1917 10.3334 22.6693 10.3334 22.025V15.4953L2.59202 5.89919C2.3099 5.54947 2.25368 5.06881 2.4475 4.66343Z" fill="#6E6E70"/>
              </svg>
          </div>
          <RowAnt gutter={12} className='rate-filter-form-content'>
            <ColAnt style={{marginBottom: 12}} span={6}>
                {filterLoanTerms()}
            </ColAnt>
            <ColAnt style={{marginBottom: 12}} span={6}>
                {filterMtypes()}
            </ColAnt>
            <ColAnt style={{marginBottom: 12}} span={6}>
                {filterAmortization()}
            </ColAnt>
            <ColAnt style={{marginBottom: 12}} span={6}>
                {filterLenders()}
            </ColAnt>
            <ColAnt style={{marginBottom: 12}} span={6}>
                {filterPropertyType()}
            </ColAnt>
            <ColAnt style={{marginBottom: 12}} span={6}>
                {filterFirstTimeHomeBuyer()}
            </ColAnt>
          </RowAnt>
      </div>
    }
    let get1003Downpayment = () => {
      if (this.props.selection.selectedloan.hash !== "") {
       return com.safeParseInt(this.props.property.salesprice) - this.props.selection.loansize
      } else {
       return com.safeParseInt(this.props.selection.downpayment)
      }
    }
    let get1003PaydownPrincipal = () => {
        if (this.props.selection.selectedloan.hash !== "") {
            return com.safeParseInt(this.props.application.loanbalance) - this.props.selection.loansize
        } else {
            return com.safeParseInt(this.props.selection.paydown)
        }
    }
    let get1003Cashout = () => {
        if (this.props.selection.selectedloan.hash !== "") {
            return this.props.selection.loansize - com.safeParseInt(this.props.application.loanbalance)
        } else {
            return com.safeParseInt(this.props.selection.cashout)
        }
    }
    let updateDownpayment = () => {
        let dp = this.state.defdownpayment
        let ls = this.state.propertyvalue - parseFloat(dp)
        this.props.updateSelectField(com.safeParseInt(dp), "downpayment")
        this.props.updateSelectField(ls.toString(), "loansize")
        const loanId = this.getLoanId()
        if (loanId) {
          this.persistUpdateToV2([
            patchSelectionV2(loanId, {
              downpayment: `${com.safeParseInt(dp)}`,
              loansize: `${ls}`,
            }),
          ])
        }
    }
    let updatePaydownPrincipal = () => {
        let dp = this.state.defdownpayment
        let ls = com.safeParseInt(this.state.currentbalance) - parseFloat(dp)
        this.props.updateSelectField(com.safeParseInt(dp), "downpayment")
        this.props.updateSelectField(com.safeParseInt(dp), "paydown")
        this.props.updateSelectField(ls.toString(), "loansize")
        const loanId = this.getLoanId()
        if (loanId) {
          this.persistUpdateToV2([
            patchSelectionV2(loanId, {
              downpayment: `${com.safeParseInt(dp)}`,
              paydown: `${com.safeParseInt(dp)}`,
              loansize: `${ls}`,
            }),
          ])
        }
    }
    let updateCashout = () => {
        let dp = this.state.defdownpayment
        let ls = com.safeParseInt(this.state.currentbalance) + parseFloat(dp)
        this.props.updateSelectField(ls.toString(), "loansize")
        this.props.updateSelectField(com.safeParseInt(dp), "cashout")
        const loanId = this.getLoanId()
        if (loanId) {
          this.persistUpdateToV2([
            patchSelectionV2(loanId, {
              loansize: `${ls}`,
              cashout: `${com.safeParseInt(dp)}`,
            }),
          ])
        }
    }
    let purchase = () => {
      return (
        <div style={{ overflow: "hidden", position: "relative" }}>
          <RowAnt
            gutter={12}
            className="productPickerFiltersWrap"
            ref={this.filtersWrapRef}
            onScroll={this.handleScroll}
          >
            <ColAnt span={4}>
                {propertyValue()}
            </ColAnt>
            <ColAnt span={4}>
              <div className='rate-filter-item'>
                <FilterItem title="Down Payment">
                    <InputNumber
                        size="middle"
                        style={{width: '100%'}}
                        className="all-rates-input"
                        min={0}
                        controls={false}
                        status={this.amountWarning() ? 'warning' : ''}
                        suffix={warningSuffix(this.amountWarning(), this.warningIcon())}
                        prefix="$"
                        formatter={formatDollars}
                        parser={parseDollars}
                        value={this.state.defdownpayment}
                        onChange={this.changeDownpayment}
                    />
                </FilterItem>
                <div className='rate-filter-item-update'>
                    <div>Current 1003 value:</div>
                    <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(get1003Downpayment())}</span>. <span className='rate-filter-item-update-btn' onClick={updateDownpayment}>Update</span></div>
                </div>
              </div>
            </ColAnt>

            <ColAnt span={4}>
                {filterTargetPrice()}
            </ColAnt>
            <ColAnt span={4}>
                {estimatedFICO()}
            </ColAnt>
            <ColAnt span={4}>
                {propertyState()}
            </ColAnt>
            <ColAnt span={4}>
                {propertyCounty()}
            </ColAnt>
            <ColAnt span={4}>
                {filterIncome()}
            </ColAnt>
            <ColAnt span={4}>
                {filterLiability()}
            </ColAnt>
            <ColAnt span={16}>
                {filterActionBar()}
            </ColAnt>
          </RowAnt>
          {this.state.showFilterForm && filterForm()}
        </div>
      );
    };

    let refinance = () => {
      return (
        <div style={{ overflow: "hidden", position: "relative" }}>
          <RowAnt
            gutter={12}
            className="productPickerFiltersWrap"
            ref={this.filtersWrapRef}
            onScroll={this.handleScroll}
          >
            <ColAnt span={4}>
                {propertyValue()}
            </ColAnt>
            <ColAnt span={4}>
                {currentBalance()}
            </ColAnt>
            <ColAnt span={4}>
              <div className='rate-filter-item'>
                  <FilterItem title="Paydown principal">
                      <InputNumber
                          style={{width: '100%'}}
                          className="all-rates-input"
                          min={0}
                          controls={false}
                          status={this.amountWarning() ? 'warning' : ''}
                          suffix={warningSuffix(this.amountWarning(), this.warningIcon())}
                          prefix="$"
                          formatter={formatDollars}
                          parser={parseDollars}
                          value={this.state.defdownpayment}
                          onChange={this.changePaydown}
                      />
                  </FilterItem>
                  <div className='rate-filter-item-update'>
                      <div>Current 1003 value:</div>
                      <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(get1003PaydownPrincipal())}</span>. <span className='rate-filter-item-update-btn' onClick={updatePaydownPrincipal}>Update</span></div>
                  </div>
              </div>
            </ColAnt>
            <ColAnt span={4}>
                {filterTargetPrice()}
            </ColAnt>
            <ColAnt span={4}>
                {estimatedFICO()}
            </ColAnt>
            <ColAnt span={4}>
                {propertyState()}
            </ColAnt>
            <ColAnt span={4}>
                {propertyCounty()}
            </ColAnt>
            <ColAnt span={4}>
                {filterIncome()}
            </ColAnt>
            <ColAnt span={4}>
                {filterLiability()}
            </ColAnt>
            <ColAnt span={12}>
                {filterActionBar()}
            </ColAnt>
          </RowAnt>
          {this.state.showFilterForm && filterForm()}
        </div>
      );
    };

    let cashout = () => {
      return (
        <div style={{ overflow: "hidden", position: "relative" }}>
          <RowAnt
            gutter={12}
            className="productPickerFiltersWrap"
            ref={this.filtersWrapRef}
            onScroll={this.handleScroll}
          >
            <ColAnt span={4}>
                {propertyValue()}
            </ColAnt>
            <ColAnt span={4}>
                {currentBalance()}
            </ColAnt>
            <ColAnt span={4}>
              <div className='rate-filter-item'>
                <FilterItem title="Cash out">
                    <InputNumber
                    style={{width: '100%'}}
                    className="all-rates-input"
                    min={0}
                    controls={false}
                    status={this.amountWarning() ? 'warning' : ''}
                    suffix={warningSuffix(this.amountWarning(), this.warningIcon())}
                    prefix="$"
                    formatter={formatDollars}
                    parser={parseDollars}
                    value={this.state.defdownpayment}
                    onChange={this.changeCashout}
                />
                </FilterItem>
                <div className='rate-filter-item-update'>
                    <div>Current 1003 value:</div>
                    <div><span className='rate-filter-item-update-value'>$ {com.commaizeFloat(get1003Cashout())}</span>. <span className='rate-filter-item-update-btn' onClick={updateCashout}>Update</span></div>
                </div>
              </div>
            </ColAnt>
            <ColAnt span={4}>
                {filterTargetPrice()}
            </ColAnt>
            <ColAnt span={4}>
                {estimatedFICO()}
            </ColAnt>
            <ColAnt span={4}>
                {propertyState()}
            </ColAnt>
            <ColAnt span={4}>
                {propertyCounty()}
            </ColAnt>
            <ColAnt span={4}>
                {filterIncome()}
            </ColAnt>
            <ColAnt span={4}>
                {filterLiability()}
            </ColAnt>
            <ColAnt span={12}>
                {filterActionBar()}
            </ColAnt>
          </RowAnt>
          {this.state.showFilterForm && filterForm()}
        </div>
      );
    };

    switch (this.props.property.purpose) {
      case "purchase":
        return purchase();
      case "refinance":
        return refinance();
      case "cashoutrefinance":
        return cashout();
      default:
        // alert("should not see this!")
        return "";
    }
  };
  getClosingCosts = (card) => {
    let cc = card.closing_cost;

    if (cc < 0) cc = 0;
    return cc;
  };
  deleteSelection = () => {
    com.touch();
    this.props.updateSelectField(new ChosenLoan(), "selectedloan");
  };


  displayFilters = () => {
    return (
      <div>
        <div>{this.printDownpayment()}</div>
      </div>
    );
  };

  displayRates = () => {
    let getName = (card) => {
      if (this.referi && this.referi[card.hash] != null) {
        let r = this.referi[card.hash][0];
        return (
          <div>
            <div>{com.formatLenderDisplayName(r["Lender"])}</div>
            <div style={{ fontWeight: 400 }}>{r["Name"]}</div>
          </div>
        );
      }
      return com.capitalize(
        card.Mtype.replace("_", " ").toLowerCase().replace("fha", "FHA")
      );
    };
    let handleSelectRate = (card) => {
      // 清除所有已选择的项目，然后只添加当前选择的项目
      // 如果点击的是已选中的项 则取消选中
      if (this.state.ratesToBeRecommended.some(x => x.hash === card.hash)) {
        this.setState({ ratesToBeRecommended: this.state.ratesToBeRecommended.filter(x => x.hash !== card.hash) });
      } else {
        this.setState({ ratesToBeRecommended: [card] });
      }
    };
    let displayErrors = () => {
      return <div className="p-3">{this.state.errorText}</div>;
    };

    const columns = [
      {
        title: "Program",
        width: 235,
        dataIndex: "program",
        render: (text, record) => {
          return getName(record);
        },
      },
      {
        title: "Rate",
        dataIndex: "rate",
        render: (text, record) => (
          <div style={{ fontWeight: 600 }}>{record.base_rate}%</div>
        ),
        sorter: (a, b) => a.base_rate - b.base_rate,
        // defaultSortOrder: "ascend",
        // sortDirections: ["descend", "ascend", "descend"],
        sortOrder: this.state.sortColumn === 'rate' ? this.state.sortOrder : null,
      },
      {
        title: "APR",
        dataIndex: "apr",
        render: (text, record) => (
          <div style={{ fontWeight: 600 }}>{record.APR}%</div>
        ),
        sorter: (a, b) => a.APR - b.APR,
        sortOrder: this.state.sortColumn === 'apr' ? this.state.sortOrder : null,
      },
      {
        title: "Mo. Payment",
        dataIndex: "monthlypayment",
        render: (text, record) => (
          <div>${com.commaize(record.monthly_payment)}</div>
        ),
        sorter: (a, b) => a.monthly_payment - b.monthly_payment,
        sortOrder: this.state.sortColumn === 'monthlypayment' ? this.state.sortOrder : null,
      },
      {
        title: "Points",
        dataIndex: "points",
        render: (text, record) => (
          <div>{record.points + "%/$" + record.lender_credit}</div>
        ),
        sorter: (a, b) => a.points - b.points,
        sortOrder: this.state.sortColumn === 'points' ? this.state.sortOrder : null,
      },
      {
        title: "Closing cost",
        dataIndex: "closingCost",
        render: (text, record) => (
          <div>
              {record.closing_cost < 0
                ? `$-${com.commaize(Math.abs(record.closing_cost))}`
                : `$${com.commaize(Math.abs(record.closing_cost))}`
              }
          </div>
        ),
        sorter: (a, b) => a.closing_cost - b.closing_cost,
        sortOrder: this.state.sortColumn === 'closingCost' ? this.state.sortOrder : null,
      },
      {
        title: "",
        dataIndex: "add",
        width: 116,
        render: (text, record) => {
          // 检查是否有任何选择，以及当前记录是否被选中
          const hasSelection = this.state.ratesToBeRecommended.length > 0;
          const isSelected = this.state.ratesToBeRecommended.some(
            (x) => x.hash === record.hash
          );
          // 如果有选择但当前记录未被选中，则禁用按钮
          const isDisabled = hasSelection && !isSelected;
          
          return (
            <div style={{ gap: 20 }} className="d-flex align-items-center">
              {
              !this.isPrequal && 
              (
                <Button
                  className={`${
                    isSelected ? "rate-selected-btn" : ""
                  } rate-normal-btn`}
                  onClick={() => handleSelectRate(record)}
                  disabled={isDisabled}
                  // color={ isSelected ? "#325CEB" : "default" } 
                  // variant={ isSelected ? "link" : "default" }
                >
                  {isSelected ? "Selected" : "Select"}
                </Button>
              )}
            </div>
          );
        },
      },
    ];
    return (
      <div>
        {/* {this.state.loading && (
          <div className="p-2 mt-2">
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </div>
        )} */}
        {/* {this.state.products.length === 0 &&
          !this.state.loading &&
          displayErrors()} */}
        <Table
          className="rates-recommended-filter-table"
          loading={this.state.loading}
          columns={columns}
          dataSource={this.state.products}
          showSorterTooltip={false}
          // pagination={false}
          scroll={{ y: 'calc(100vh - 466px)' }}
          style={{
            height: 'calc(100vh - 466px)',
            marginBottom: 100,
          }}
          onChange={(pagination, filters, sorter) => {
            this.setState({
                sortOrder: sorter.order,
                sortColumn: sorter.field
            });
          }}
          locale={{
            emptyText: <div className='rates-recommended-table-empty text-center'>
              <div className='empty-data-icon'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58" fill="none">
                      <rect y="3.0127" width="33.1262" height="37.6434" rx="2" fill="#C3CDEA"/>
                      <rect y="3.0127" width="33.1262" height="37.6434" rx="2" fill="#DFE0E8"/>
                      <rect x="13.5522" y="12.0469" width="33.1262" height="33.1262" rx="11" fill="#A4B7F8"/>
                      <rect x="4.51807" y="9.03516" width="24.0918" height="3.01147" rx="1.50573" fill="white"/>
                      <rect x="4.51807" y="16.5635" width="24.0918" height="3.01147" rx="1.50573" fill="white"/>
                      <path d="M15.0581 19.0576C15.0581 16.8485 16.849 15.0576 19.0581 15.0576H33.1269C34.7901 15.0576 36.1384 16.4059 36.1384 18.0691C36.1384 19.7323 34.7901 21.0806 33.1269 21.0806H15.0581V19.0576Z" fill="white"/>
                      <rect x="4.51807" y="24.0928" width="9.03441" height="3.01147" rx="1.50573" fill="white"/>
                      <rect x="10.54" y="25.5986" width="25.5975" height="6.02294" rx="3.01147" fill="white"/>
                      <rect x="13.7212" y="36.3613" width="22.6397" height="6.17446" rx="3.08723" fill="white"/>
                      <rect x="4.51807" y="31.6211" width="9.03441" height="3.01147" rx="1.50573" fill="white"/>
                      <path d="M15.8779 14.3746C23.8161 6.43629 36.6871 6.43573 44.6255 14.3739C52.5638 22.3122 52.5638 35.1839 44.6255 43.1222C36.6871 51.0604 23.8161 51.0598 15.8779 43.1215C7.93976 35.1832 7.93976 22.3129 15.8779 14.3746ZM18.8506 17.3487C12.5548 23.6447 12.5554 33.8522 18.8513 40.1481C25.1472 46.4439 35.3547 46.4445 41.6507 40.1488C47.9466 33.8528 47.9466 23.6446 41.6507 17.3487C35.3547 11.0528 25.1465 11.0528 18.8506 17.3487Z" fill="#525F9D"/>
                      <rect x="41.3613" y="43.0459" width="4.5172" height="12.0459" rx="2.2586" transform="rotate(-45 41.3613 43.0459)" fill="#525F9D"/>
                  </svg>
              </div>
              {this.state.products.length === 0 && !this.state.loading && this.state.errorText ? displayErrors() : <div className='empty-data-title'>Please ensure all required fields are filled out.</div>}
          </div>
        }}
        />
      </div>
    );
  };

  checkStatus = () => {
    let token = sessionStorage.getItem("ZeitroA");
    if (this.props.application.remotecoborrowers.length > 0) {
      this.setState({ statusloaded: false });
      fetch("/data/coborrowerstatus", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          Cache: "no-cache",
          "X-Borrower": this.props.borrowerid,
        },
      })
        .then((response) => {
          if (response.status !== 200) {
            return;
          }
          response.json().then((js) => {
            let positionbyemail = {};
            let proc = (a, i) => {
              let email = a.Email;
              let position = a.Position;
              positionbyemail[email] = position;
            };
            js.map(proc);
            this.setState({
              positionbyemail: positionbyemail,
              statusloaded: true,
            });
          });
        })
        .catch((err) => {
          alert("Fetch Error :", err);
        });
    }
  };

  renderRemoteCoborrowers = (rb, i) => {
    let getStatus = () => {
      let status = "Invited";
      if (rb.email in this.state.positionbyemail) {
        let pos = this.state.positionbyemail[rb.email];

        status = com.positionToStatus(pos);
      }
      return status;
    };
    if (this.state.positionbyemail[rb.email] >= com.prefillLimit)
      return <div></div>;
    else {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.checkStatus, 30000);
      return (
        <div className="viewport mb-3 drop-shadow text-left" key={rb.key}>
          <Form.Row>
            <Col>
              <Form.Group
                controlId={"first_name" + rb.key}
                className="text-left"
              >
                <Form.Label className="text-left">First Name:</Form.Label>
                <br />
                <div style={{ fontSize: "1.2em" }}>{rb.firstname}</div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group
                controlId={"last_name" + rb.key}
                className="text-left"
              >
                <Form.Label className="text-left">Last Name:</Form.Label>
                <br />
                <div style={{ fontSize: "1.2em" }}>{rb.lastname}</div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId={"email" + rb.key} className="text-left">
                <Form.Label className="text-left">Email:</Form.Label>
                <br />
                <div style={{ fontSize: "1.2em" }}>{rb.email}</div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId={"email" + rb.key} className="text-left">
                <Form.Label className="text-left">Status:</Form.Label>
                <br />
                <div style={{ fontSize: "1.2em" }}>{getStatus()}</div>
              </Form.Group>
            </Col>
          </Form.Row>
        </div>
      );
    }
  };

  waiting = (num) => {
    return (
      <div className="mx-2 px-2 text-left  mb-4 bg-">
        <h2 className=" heading">Product selector</h2>
        <div className="viewport text-center mt-4 ">
          <div className="mb-3 sectionquestion">
            {num === 1 ? (
              <div>
                Look like your coborrower has not filled enough of their
                application to allow product selection:
              </div>
            ) : (
              <div>
                Look like some of your coborrowers have not filled enough of
                their application to allow product selection:
              </div>
            )}
          </div>
          {this.props.application.remotecoborrowers.map(
            this.renderRemoteCoborrowers
          )}
        </div>
      </div>
    );
  };
  generateDTISpreadsheet = () => {
    this.setState({ dtiSpreadsheetLoading: true }, () => {
      setTimeout(() => {
        // wait for 5 seconds for updating selected loan state
        let token = sessionStorage.getItem("ZeitroA");
        fetch("/los/generatedtispreadsheet", {
          cache: "no-cache",
          method: "POST",
          body: JSON.stringify({
            CustomerID: this.props.borrower.id,
            LoanID: this.props.borrower.loan_id,
          }),
          headers: {
            Authorization: "Bearer " + token,
            Cache: "no-cache",
          },
        }).then((response) => {
          if (response.status !== 200) {
            this.setState({ dtiSpreadsheetLoading: false });
            alert("Something went wrong, please try later.");
            return;
          }
          response.json().then((js) => {
            if (js.RedirectURL !== "Something is wrong") {
              this.setState({ DTISpreadsheet: js.SpreadsheetB64 }, () =>
                this.downloadDTIspreadsheetRef.current.click()
              );
            } else {
              alert("Something went wrong, please try later.");
            }
            this.setState({ dtiSpreadsheetLoading: false });
          });
        });
      }, 5 * 1000);
    });
  };
  clearSelected = () => {
    this.setState({ ratesToBeRecommended: [] });
  };
  compareData = () => {
    return this.state.ratesToBeRecommended.map((data) => {
      // 与ProductPicker保持一致，无论贷款类型如何，都使用 salesprice - downpayment
      return {
        ...data,
        key: data.hash,
        Lender:
          this.referi && this.referi[data.hash] != null
            ? this.referi[data.hash][0]["Lender"]
            : "",
        Name:
          this.referi && this.referi[data.hash] != null
            ? this.referi[data.hash][0]["Name"]
            : "",
        loanAmount: this.props.property.salesprice - this.state.downpayment, // 与ProductPicker保持一致
        rate: data.base_rate,
      };
    });
  };
  showModal = () => {
    this.setState({ visible: true }, () => {
      // 在弹窗打开后获取数据
      this.getFeeConfig();
    });
  };
  handleOk = () => {
    this.setState({ isModalOpen: false });
  };
  handleCancel = () => {
    this.setState({ isModalOpen: false });
  };
  cancelSelect = (key) => {
    this.setState((prevState) => ({
      ratesToBeRecommended: prevState.ratesToBeRecommended.filter(
        (item) => item.hash !== key
      ),
    }));
  };

  getLoanId = () => this.props.loanid || this.props.loadid || this.props.borrower?.loan_id || ""

  // V2 loans skip loanstates sync, so Redux-only Update never reaches 1003.
  // Mirror ProductPickerV2: also PATCH the V2 endpoints and refresh the parent.
  persistUpdateToV2 = (tasks) => {
    const loanId = this.getLoanId()
    if (!loanId || !tasks?.length) return
    Promise.all(tasks)
      .then((bodies) => {
        const application = [...bodies].reverse().find((body) => body?.Application)?.Application
        if (application && this.props.onApplicationChange) {
          this.props.onApplicationChange(application)
        }
      })
      .catch((err) => console.error(err))
  }

  // 添加一个方法用于重置组件状态
  resetState = () => {
    // 根据贷款目的重新计算初始状态
    let initialLoanSize = 0;
    let initialDownPayment = 0;
    this.state.income = this.pricingIncome()
    this.state.liabilities = this.pricingLiabilities()
    let propertyvalue = this.props.application.property.purpose === "purchase" ? this.props.application.property.salesprice : this.props.application.property.appraisal
    this.state.propertytype = this.props.application.property.propertytype === "mobilehome" ? "manufacturedhome" : this.props.application.property.propertytype
    this.state.propertyvalue = com.safeParseInt(propertyvalue)
    this.state.propertystate = this.props.application.property.state
    this.state.propertycounty = this.props.application.property.county
    this.state.firstTimeHomeBuyer = this.props.application.firsttimebuyer
    this.state.currentbalance = com.safeParseInt(this.props.application.loanbalance)
    switch (this.props.property.purpose) {
      case "purchase":
        if (this.props.selection.selectedloan.hash !== "") {
          initialLoanSize = this.props.selection.loansize;
          initialDownPayment = com.safeParseInt(this.props.property.salesprice) - initialLoanSize;
        } else {
          initialDownPayment = com.safeParseInt(this.props.selection.downpayment);
          initialLoanSize = com.safeParseInt(this.props.property.salesprice) - initialDownPayment;
        }
        break;
      case "refinance":
        if (this.props.selection.selectedloan.hash !== "") {
          initialLoanSize = this.props.selection.loansize;
          initialDownPayment = com.safeParseInt(this.props.application.loanbalance) - initialLoanSize;
        } else {
          initialDownPayment = com.safeParseInt(this.props.selection.paydown);
          initialLoanSize = com.safeParseInt(this.props.application.loanbalance) - initialDownPayment;
        }
        break;
      case "cashoutrefinance":
        if (this.props.selection.selectedloan.hash !== "") {
          initialLoanSize = this.props.selection.loansize;
          initialDownPayment = initialLoanSize - com.safeParseInt(this.props.application.loanbalance);
          if (initialDownPayment <= 0) {
            initialDownPayment = 30000;
          }
        } else {
          initialDownPayment = com.safeParseInt(this.props.selection.cashout);
          initialLoanSize = com.safeParseInt(this.props.application.loanbalance) + initialDownPayment;
        }
        break;
      default:
        break;
    }

    // V2 loans: the scenario saved by the last rate selection or DTI calculator (DTI
    // settings, not the 1003) is where the LO left off.
    const saved = this.props.dtiEstimator || {}
    if (this.props.property.purpose === "purchase") {
      if (saved.propertyValue !== undefined) this.state.propertyvalue = com.safeParseInt(saved.propertyValue)
      if (saved.downpayment !== undefined) initialDownPayment = com.safeParseInt(saved.downpayment)
      if (saved.propertyValue !== undefined || saved.downpayment !== undefined) initialLoanSize = this.state.propertyvalue - initialDownPayment
    } else {
      if (saved.currentLoanBalance !== undefined) this.state.currentbalance = com.safeParseInt(saved.currentLoanBalance)
      if (saved.loanAmount !== undefined) initialLoanSize = com.safeParseInt(saved.loanAmount)
      const amountKey = this.props.property.purpose === "refinance" ? "paydown" : "cashoutAmount"
      if (saved[amountKey] !== undefined) initialDownPayment = com.safeParseInt(saved[amountKey])
    }

    // 重置本地状态
    this.setState({
      loansize: initialLoanSize,
      downpayment: initialDownPayment,
      defdownpayment: initialDownPayment,
      products: [],
      topProducts: [],
      loading: false,
      errorText: "",
      ratesToBeRecommended: [],
      ltv: (100 * initialLoanSize) / this.props.property.salesprice,
      // 重置筛选器状态
      typeselected: this.props.selection.loanamortizations.length ? 
                   typeoptions.filter(opt => this.props.selection.loanamortizations.includes(opt.value)).map(opt => opt.value) : 
                   ['all'],//typeoptions.map(x => x.value),
      termselected: this.props.selection.loanterms.length ? 
                  (this.getTermOptions().filter(term => this.props.selection.loanterms.includes("year" + term.value)).length === this.getTermOptions().length ? ['all'] : this.getTermOptions().filter(term => this.props.selection.loanterms.includes("year" + term.value)).map(term => term.value)) :
                  [this.getTermOptions()[0].value],
      lenders: [],
      selectedlenders: ['all'],
      mtypes: [],
      selectedmtypes: ['all'],
      incomedoctypes: [],
      selectedincomedoctypes: [],


      // 重置其他筛选相关状态
      selectedmaxreserves: -1,
      maxreserves: -1,
      fico: this.props.application.scre || 740, // 使用应用程序中的信用分数或默认值
    });
    
    // 重置实例变量
    this.lenders = [];
    this.mtypes = [];
    this.incomedoctypes = [];
    this.rawproducts = [];
    this.referi = {};
    
    // 重置maxupfrontcost
    this.oldmaxupfrontcost = null;
    
    // 更新Redux状态
    this.props.updateSelectField(initialLoanSize.toString(), "loansize");
    
    // 根据贷款目的更新相应字段
    switch (this.props.property.purpose) {
      case "purchase":
        this.props.updateSelectField(initialDownPayment, "downpayment");
        break;
      case "refinance":
        this.props.updateSelectField(initialDownPayment, "paydown");
        break;
      case "cashoutrefinance":
        this.props.updateSelectField(initialDownPayment, "cashout");
        break;
      default:
        break;
    }
    
    // 重置Redux中的maxupfrontcost
    this.props.updateSelectField("", "maxupfrontcost");
  };
  
  // 处理Modal关闭
  handleModalClose = () => {
    // 清理状态
    this.setState({
      products: [],
      topProducts: [],
      ratesToBeRecommended: [],
      errorText: "",
      isEditFilter: false
    });
    
    // 调用父组件的onCancel回调
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  confirm = () => {
    // console.log('confirm-------', this.state.ratesToBeRecommended)
    // V2 loan pages persist through onDTICalculationChange; Redux is never saved there.
    const updateDTICalculation = this.props.onDTICalculationChange || this.props.updateDTICalculation
    updateDTICalculation(this.state.ratesToBeRecommended[0].base_rate, "rate")
    updateDTICalculation(this.state.ratesToBeRecommended[0].monthly_payment, "monthlyPayment")
    // V2 loans keep the scenario this rate was priced on (value, down payment, term, MI)
    // with the DTI settings, so the DTI payment matches the rate picked.
    if (this.props.onRateScenario) {
      const card = this.state.ratesToBeRecommended[0]
      this.props.onRateScenario({
        propertyValue: com.safeParseInt(this.state.propertyvalue),
        downpayment: com.safeParseInt(this.state.downpayment),
        loanSize: com.safeParseInt(this.state.loansize),
        currentBalance: com.safeParseInt(this.state.currentbalance),
        term: com.safeParseInt(card.Term),
        pmi: Number(card.PMICost) || 0,
      })
    }

    if (this.props.onConfirm) {
      this.props.onConfirm(this.state.ratesToBeRecommended[0].base_rate);
    }
    // this.setState({ isModalOpen: false });
  }

  componentDidUpdate(prevProps, nextState) {
    // 当Modal从关闭变为打开状态时，重新加载数据
    if (prevProps.open === false && this.props.open === true) {
      // 确保有borrowerid才调用getFees
      if (this.props.borrowerid) {
        // 重置状态
        this.resetState();
        
        // 设置一个短暂的延迟，确保状态更新后再调用getFees
        setTimeout(() => {
          this.getFeeConfig();
        }, 100);
      } else {
        console.warn("No borrowerid found, cannot load product data");
        this.setState({ 
          errorText: "No borrowerid found, cannot load product data", 
          loading: false 
        });
      }
    }
    // if(this.props.borrowerid !== prevProps.borrowerid) {
    //   if (this.props.borrowerid)
    //       this.howmany2display = 15
    // }
    // 只在必要时更新
    return (
      this.props.borrower !== prevProps.borrower ||
      this.props.property !== prevProps.property ||
      this.state.loading !== nextState.loading
    );
  }
  render = () => {
    if (this.props.application.hascoborrower === "multiple") {
      if (!this.state.statusloaded) {
        return (
          <div className="mb-5 pb-3">
            <Row>
              <Col className="text-center mt-5 pt-5">
                <img alt="" className="rotate" src="/logo.svg"></img>
              </Col>
            </Row>
          </div>
        );
      }

      let notready = 0;
      let remotes = this.props.application.remotecoborrowers;

      for (let i = 0; i < remotes.length; i++) {
        let pos = this.state.positionbyemail[remotes[i].email];
        if (pos < com.prefillLimit) notready += 1;
      }
      if (notready > 0) {
        return <div>{this.waiting(notready)}</div>;
      }
    }
    
    // 主要内容
    const content = (
      <Container
        id="picker"
        className="text-center mt-0 mb-2 pt-0 w-100 px-0 mx-0"
        fluid
      >
        <Row className="text-left ">
          <Col>
            <div>{this.displayFilters()}</div>
            <div>{this.displayRates()}</div>
          </Col>
        </Row>
        <Mod
          title=""
          open={this.state.isModalOpen}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <div
            style={{
              fontFamily: "Inter",
              fontSize: 16,
              lineHeight: "24px",
              color: "#222",
            }}
          >
            <div>Loan purpose is missing.</div>{" "}
            <div>Please provide additional information to proceed.</div>
          </div>
        </Mod>
      </Container>
    );

    // 使用Modal包装整个组件内容
    return (
      <Modal
        show={this.props.open || false}
        onHide={this.handleModalClose}
        dialogClassName="product-filter-modal"
        size="xl"
        destroyOnClose={true}
        backdrop="static"
        keyboard={false}
        style={{
          overflow: 'hidden',
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="rate-selector-title">Rate selection</div>
         </Modal.Title>
        </Modal.Header>
        <Modal.Body
        style={{ 
          height: 'calc(100vh - 250px)',
          overflow: 'hidden',
          padding: '0 20px'
        }}>
            <div className="rate-selector-title-content">
                Select a rate based on available info to unlock features like DTI
                calculation. For a more detailed rate recommendation and the ability
                to compare multiple options, visit the "Rate" page for the full
                experience.
            </div>
            {content}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between" style={{ width: '100%' }}>
            <Button style={{
              fontFamily: "Inter",
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: 20,
            }} color="#325CEB" variant="link" size="large" onClick={this.handleModalClose}>
              Cancel
            </Button>
            <Button style={{
              fontFamily: "Inter",
              fontSize: 16,
              fontStyle: "normal",
              fontWeight: 600,
              lineHeight: 20,
            }} 
              disabled={this.state.ratesToBeRecommended.length === 0}
              color={this.state.ratesToBeRecommended.length > 0 ? "#325CEB" : "#d9d9d9"} variant="solid" size="large" type="primary" onClick={this.confirm}>
              Done
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };
  getTermOptions = () => {
    const options = [
        { label: '25 year', value: 25 },
        { label: '20 year', value: 20 },
        { label: '15 year', value: 15 },
        { label: '10 year', value: 10 }
    ];
    if (this.state.propertytype !== "manufacturedhome") {
        options.unshift({ label: '30 year', value: 30 });
    }
    return options;
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(ProductFilterModal);
